// AUTO-GENERATED from Unicode CLDR (cldr-subdivisions-full, en) against our content valid_state_codes.
// Maps "${countryCode}-${subdivisionCode}" -> English subdivision name. Do not edit by hand; regenerate from CLDR.
// Coverage: 3317/3438 codes named by CLDR; codes absent here fall back to the raw code.
export const SUBDIVISION_NAMES: Record<string, string> = {
  "AD-02": "Canillo",
  "AD-03": "Encamp",
  "AD-04": "La Massana",
  "AD-05": "Ordino",
  "AD-06": "Sant Julià de Lòria",
  "AD-07": "Andorra la Vella",
  "AD-08": "Escaldes-Engordany",
  "AE-AJ": "Ajman",
  "AE-AZ": "Abu Dhabi",
  "AE-DU": "Dubai",
  "AE-FU": "Fujairah",
  "AE-RK": "Ras al-Khaimah",
  "AE-SH": "Sharjah",
  "AE-UQ": "Umm al-Quwain",
  "AF-BAL": "Balkh",
  "AF-BAM": "Bamyan",
  "AF-BDG": "Badghis",
  "AF-BDS": "Badakhshan",
  "AF-BGL": "Baghlan",
  "AF-DAY": "Daykundi",
  "AF-FRA": "Farah",
  "AF-FYB": "Faryab",
  "AF-GHA": "Ghazni",
  "AF-GHO": "Ghōr",
  "AF-HEL": "Helmand",
  "AF-HER": "Herat",
  "AF-JOW": "Jowzjan",
  "AF-KAB": "Kabul",
  "AF-KAN": "Kandahar",
  "AF-KAP": "Kapisa",
  "AF-KDZ": "Kunduz",
  "AF-KHO": "Khost",
  "AF-KNR": "Kunar",
  "AF-LAG": "Laghman",
  "AF-LOG": "Logar",
  "AF-NAN": "Nangarhar",
  "AF-NIM": "Nimruz",
  "AF-NUR": "Nuristan",
  "AF-PAN": "Panjshir",
  "AF-PAR": "Parwan",
  "AF-PIA": "Paktia",
  "AF-PKA": "Paktika",
  "AF-SAM": "Samangan",
  "AF-SAR": "Sar-e Pol",
  "AF-TAK": "Takhar",
  "AF-URU": "Urozgan",
  "AF-WAR": "Maidan Wardak",
  "AF-ZAB": "Zabul",
  "AL-01": "Berat County",
  "AL-02": "Durrës County",
  "AL-03": "Elbasan County",
  "AL-04": "Fier County",
  "AL-05": "Gjirokastër County",
  "AL-06": "Korçë County",
  "AL-07": "Kukës County",
  "AL-08": "Lezhë County",
  "AL-09": "Dibër County",
  "AL-10": "Shkodër County",
  "AL-11": "Tirana County",
  "AL-12": "Vlorë County",
  "AM-AG": "Aragatsotn",
  "AM-AR": "Ararat",
  "AM-AV": "Armavir",
  "AM-ER": "Yerevan",
  "AM-GR": "Gegharkunik",
  "AM-KT": "Kotayk",
  "AM-LO": "Lori",
  "AM-SH": "Shirak",
  "AM-SU": "Syunik",
  "AM-TV": "Tavush",
  "AM-VD": "Vayots Dzor",
  "AO-BGO": "Bengo",
  "AO-BGU": "Benguela",
  "AO-BIE": "Bié",
  "AO-CAB": "Cabinda",
  "AO-CCU": "Cuando Cubango",
  "AO-CNN": "Cunene",
  "AO-CNO": "Cuanza Norte",
  "AO-CUS": "Cuanza Sul",
  "AO-HUA": "Huambo",
  "AO-HUI": "Huíla",
  "AO-LNO": "Lunda Norte",
  "AO-LSU": "Lunda Sul",
  "AO-LUA": "Luanda",
  "AO-MAL": "Malanje",
  "AO-MOX": "Moxico",
  "AO-NAM": "Namibe",
  "AO-UIG": "Uíge",
  "AO-ZAI": "Zaire",
  "AR-A": "Salta",
  "AR-B": "Buenos Aires Province",
  "AR-C": "Buenos Aires",
  "AR-D": "San Luis",
  "AR-E": "Entre Ríos",
  "AR-F": "La Rioja",
  "AR-G": "Santiago del Estero",
  "AR-H": "Chaco",
  "AR-J": "San Juan",
  "AR-K": "Catamarca",
  "AR-L": "La Pampa",
  "AR-M": "Mendoza",
  "AR-N": "Misiones",
  "AR-P": "Formosa",
  "AR-Q": "Neuquén",
  "AR-R": "Río Negro",
  "AR-S": "Santa Fe",
  "AR-T": "Tucumán",
  "AR-U": "Chubut",
  "AR-V": "Tierra del Fuego",
  "AR-W": "Corrientes",
  "AR-X": "Córdoba",
  "AR-Y": "Jujuy",
  "AR-Z": "Santa Cruz",
  "AT-1": "Burgenland",
  "AT-2": "Carinthia",
  "AT-3": "Lower Austria",
  "AT-4": "Upper Austria",
  "AT-5": "Salzburg",
  "AT-6": "Styria",
  "AT-7": "Tyrol",
  "AT-8": "Vorarlberg",
  "AT-9": "Vienna",
  "AU-ACT": "Australian Capital Territory",
  "AU-NSW": "New South Wales",
  "AU-NT": "Northern Territory",
  "AU-QLD": "Queensland",
  "AU-SA": "South Australia",
  "AU-TAS": "Tasmania",
  "AU-VIC": "Victoria",
  "AU-WA": "Western Australia",
  "AZ-ABS": "Absheron",
  "AZ-AGA": "Agstafa",
  "AZ-AGC": "Aghjabadi",
  "AZ-AGM": "Agdam",
  "AZ-AGS": "Agdash",
  "AZ-AGU": "Agsu",
  "AZ-AST": "Astara",
  "AZ-BA": "Baku",
  "AZ-BAB": "Babek",
  "AZ-BAL": "Balakan",
  "AZ-BAR": "Barda",
  "AZ-BEY": "Beylagan",
  "AZ-BIL": "Bilasuvar",
  "AZ-CAB": "Jabrayil",
  "AZ-CAL": "Jalilabad",
  "AZ-CUL": "Julfa",
  "AZ-DAS": "Dashkasan",
  "AZ-FUZ": "Fizuli",
  "AZ-GAD": "Gadabay",
  "AZ-GOR": "Goranboy",
  "AZ-GOY": "Goychay",
  "AZ-GYG": "Goygol",
  "AZ-HAC": "Hajigabul",
  "AZ-IMI": "Imishli",
  "AZ-ISM": "Ismailli",
  "AZ-KAL": "Kalbajar",
  "AZ-KAN": "Kangarli",
  "AZ-KUR": "Kurdamir",
  "AZ-LA": "Lankaran",
  "AZ-LAC": "Lachin",
  "AZ-LAN": "Lankaran District",
  "AZ-LER": "Lerik",
  "AZ-MAS": "Masally",
  "AZ-MI": "Mingachevir",
  "AZ-NA": "Naftalan",
  "AZ-NEF": "Neftchala",
  "AZ-OGU": "Oghuz",
  "AZ-ORD": "Ordubad",
  "AZ-QAB": "Qabala",
  "AZ-QAX": "Qakh",
  "AZ-QAZ": "Qazakh",
  "AZ-QBA": "Quba",
  "AZ-QBI": "Qubadli",
  "AZ-QOB": "Gobustan",
  "AZ-QUS": "Qusar",
  "AZ-SA": "Shaki",
  "AZ-SAB": "Sabirabad",
  "AZ-SAD": "Sadarak",
  "AZ-SAH": "Shahbuz",
  "AZ-SAK": "Shaki District",
  "AZ-SAL": "Salyan",
  "AZ-SAR": "Sharur",
  "AZ-SAT": "Saatly",
  "AZ-SBN": "Shabran",
  "AZ-SIY": "Siazan",
  "AZ-SKR": "Shamkir",
  "AZ-SM": "Sumqayit",
  "AZ-SMI": "Shamakhi",
  "AZ-SMX": "Samukh",
  "AZ-SR": "Shirvan",
  "AZ-SUS": "Shusha",
  "AZ-TAR": "Tartar",
  "AZ-TOV": "Tovuz",
  "AZ-UCA": "Ujar",
  "AZ-XA": "Stepanakert",
  "AZ-XAC": "Khachmaz",
  "AZ-XIZ": "Khizi",
  "AZ-XVD": "Khojavend",
  "AZ-YAR": "Yardymli",
  "AZ-YE": "Yevlakh",
  "AZ-YEV": "Yevlakh District",
  "AZ-ZAN": "Zangilan",
  "AZ-ZAQ": "Zaqatala",
  "AZ-ZAR": "Zardab",
  "BA-BIH": "Federation of Bosnia and Herzegovina",
  "BA-BRC": "Brčko District",
  "BA-SRP": "Republika Srpska",
  "BB-01": "Christ Church",
  "BB-02": "Saint Andrew",
  "BB-03": "Saint George",
  "BB-04": "Saint James",
  "BB-05": "Saint John",
  "BB-06": "Saint Joseph",
  "BB-07": "Saint Lucy",
  "BB-08": "Saint Michael",
  "BB-09": "Saint Peter",
  "BB-10": "Saint Philip",
  "BB-11": "Saint Thomas",
  "BD-A": "Barisal",
  "BD-B": "Chittagong Division",
  "BD-C": "Dhaka Division",
  "BD-D": "Khulna Division",
  "BD-E": "Rajshahi Division",
  "BD-F": "Rangpur Division",
  "BD-G": "Sylhet Division",
  "BD-H": "Mymensingh Division",
  "BE-BRU": "Brussels",
  "BE-VLG": "Flanders",
  "BE-WAL": "Wallonia",
  "BF-01": "Boucle du Mouhoun",
  "BF-02": "Cascades",
  "BF-03": "Centre",
  "BF-04": "Centre-Est",
  "BF-05": "Centre-Nord",
  "BF-06": "Centre-Ouest",
  "BF-07": "Centre-Sud",
  "BF-08": "Est",
  "BF-09": "Hauts-Bassins",
  "BF-10": "Nord",
  "BF-11": "Plateau-Central",
  "BF-12": "Sahel",
  "BF-13": "Sud-Ouest",
  "BG-01": "Blagoevgrad",
  "BG-02": "Burgas",
  "BG-03": "Varna",
  "BG-04": "Veliko Tarnovo",
  "BG-05": "Vidin",
  "BG-06": "Vratsa",
  "BG-07": "Gabrovo",
  "BG-08": "Dobrich",
  "BG-09": "Kardzhali",
  "BG-10": "Kyustendil",
  "BG-11": "Lovech",
  "BG-12": "Montana",
  "BG-13": "Pazardzhik",
  "BG-14": "Pernik",
  "BG-15": "Pleven",
  "BG-16": "Plovdiv",
  "BG-17": "Razgrad",
  "BG-18": "Ruse",
  "BG-19": "Silistra",
  "BG-20": "Sliven",
  "BG-21": "Smolyan",
  "BG-22": "Sofia",
  "BG-23": "Sofia District",
  "BG-24": "Stara Zagora",
  "BG-25": "Targovishte",
  "BG-26": "Haskovo",
  "BG-27": "Shumen",
  "BG-28": "Yambol",
  "BH-13": "Capital",
  "BH-14": "Southern",
  "BH-15": "Muharraq",
  "BH-17": "Northern",
  "BI-BB": "Bubanza",
  "BI-BL": "Bujumbura Rural",
  "BI-BM": "Bujumbura",
  "BI-BR": "Bururi",
  "BI-CA": "Cankuzo",
  "BI-CI": "Cibitoke",
  "BI-GI": "Gitega",
  "BI-KI": "Kirundo",
  "BI-KR": "Karuzi",
  "BI-KY": "Kayanza",
  "BI-MA": "Makamba",
  "BI-MW": "Mwaro",
  "BI-MY": "Muyinga",
  "BI-NG": "Ngozi",
  "BI-RT": "Rutana",
  "BI-RY": "Ruyigi",
  "BJ-AK": "Atakora",
  "BJ-AL": "Alibori",
  "BJ-AQ": "Atlantique",
  "BJ-BO": "Borgou",
  "BJ-CO": "Collines",
  "BJ-DO": "Donga",
  "BJ-KO": "Kouffo",
  "BJ-LI": "Littoral",
  "BJ-MO": "Mono",
  "BJ-OU": "Ouémé",
  "BJ-PL": "Plateau",
  "BJ-ZO": "Zou",
  "BN-BE": "Belait",
  "BN-BM": "Brunei-Muara",
  "BN-TE": "Temburong",
  "BN-TU": "Tutong",
  "BO-B": "Beni",
  "BO-C": "Cochabamba",
  "BO-H": "Chuquisaca",
  "BO-L": "La Paz",
  "BO-N": "Pando",
  "BO-O": "Oruro",
  "BO-P": "Potosí",
  "BO-S": "Santa Cruz",
  "BO-T": "Tarija",
  "BR-AC": "Acre",
  "BR-AL": "Alagoas",
  "BR-AM": "Amazonas",
  "BR-AP": "Amapá",
  "BR-BA": "Bahia",
  "BR-CE": "Ceará",
  "BR-DF": "Federal District",
  "BR-ES": "Espírito Santo",
  "BR-GO": "Goiás",
  "BR-MA": "Maranhão",
  "BR-MG": "Minas Gerais",
  "BR-MS": "Mato Grosso do Sul",
  "BR-MT": "Mato Grosso",
  "BR-PA": "Pará",
  "BR-PB": "Paraíba",
  "BR-PE": "Pernambuco",
  "BR-PI": "Piauí",
  "BR-PR": "Paraná",
  "BR-RJ": "Rio de Janeiro",
  "BR-RN": "Rio Grande do Norte",
  "BR-RO": "Rondônia",
  "BR-RR": "Roraima",
  "BR-RS": "Rio Grande do Sul",
  "BR-SC": "Santa Catarina",
  "BR-SE": "Sergipe",
  "BR-SP": "São Paulo",
  "BR-TO": "Tocantins",
  "BS-AK": "Acklins",
  "BS-BI": "Bimini",
  "BS-BP": "Black Point",
  "BS-BY": "Berry Islands",
  "BS-CE": "Central Eleuthera",
  "BS-CI": "Cat Island",
  "BS-CK": "Crooked Island",
  "BS-CO": "Central Abaco",
  "BS-CS": "Central Andros",
  "BS-EG": "East Grand Bahama",
  "BS-EX": "Exuma",
  "BS-FP": "Freeport",
  "BS-GC": "Grand Cay",
  "BS-HI": "Harbour Island",
  "BS-HT": "Hope Town",
  "BS-IN": "Inagua",
  "BS-LI": "Long Island",
  "BS-MC": "Mangrove Cay",
  "BS-MG": "Mayaguana",
  "BS-MI": "Moore’s Island",
  "BS-NE": "North Eleuthera",
  "BS-NO": "North Abaco",
  "BS-NP": "New Providence",
  "BS-NS": "North Andros",
  "BS-RC": "Rum Cay",
  "BS-RI": "Ragged Island",
  "BS-SA": "South Andros",
  "BS-SE": "South Eleuthera",
  "BS-SO": "South Abaco",
  "BS-SS": "San Salvador",
  "BS-SW": "Spanish Wells",
  "BS-WG": "West Grand Bahama",
  "BT-11": "Paro",
  "BT-12": "Chukha",
  "BT-13": "Haa",
  "BT-14": "Samtse",
  "BT-15": "Thimphu",
  "BT-21": "Tsirang",
  "BT-22": "Dagana",
  "BT-23": "Punakha",
  "BT-24": "Wangdue Phodrang",
  "BT-31": "Sarpang",
  "BT-32": "Trongsa",
  "BT-33": "Bumthang",
  "BT-34": "Zhemgang",
  "BT-41": "Trashigang",
  "BT-42": "Mongar",
  "BT-43": "Pemagatshel",
  "BT-44": "Lhuntse",
  "BT-45": "Samdrup Jongkhar",
  "BT-GA": "Gasa",
  "BT-TY": "Trashiyangtse",
  "BW-CE": "Central",
  "BW-CH": "Chobe",
  "BW-FR": "Francistown",
  "BW-GA": "Gaborone",
  "BW-GH": "Ghanzi",
  "BW-JW": "Jwaneng",
  "BW-KG": "Kgalagadi",
  "BW-KL": "Kgatleng",
  "BW-KW": "Kweneng",
  "BW-LO": "Lobatse",
  "BW-NE": "North East",
  "BW-NW": "North West",
  "BW-SE": "South East",
  "BW-SO": "Southern",
  "BW-SP": "Selibe Phikwe",
  "BW-ST": "Sowa Town",
  "BY-BR": "Brest",
  "BY-HM": "Minsk",
  "BY-HO": "Homel",
  "BY-HR": "Hrodna",
  "BY-MA": "Magileu",
  "BY-MI": "Minsk Region",
  "BY-VI": "Vitebsk",
  "BZ-BZ": "Belize",
  "BZ-CY": "Cayo",
  "BZ-CZL": "Corozal",
  "BZ-OW": "Orange Walk",
  "BZ-SC": "Stann Creek",
  "BZ-TOL": "Toledo",
  "CA-AB": "Alberta",
  "CA-BC": "British Columbia",
  "CA-MB": "Manitoba",
  "CA-NB": "New Brunswick",
  "CA-NL": "Newfoundland and Labrador",
  "CA-NS": "Nova Scotia",
  "CA-NT": "Northwest Territories",
  "CA-NU": "Nunavut",
  "CA-ON": "Ontario",
  "CA-PE": "Prince Edward Island",
  "CA-QC": "Quebec",
  "CA-SK": "Saskatchewan",
  "CA-YT": "Yukon",
  "CD-BC": "Bas-Congo",
  "CD-BN": "Bandundu",
  "CD-BU": "Bas-Uélé",
  "CD-EQ": "Équateur",
  "CD-HK": "Haut-Katanga",
  "CD-HL": "Haut-Lomami",
  "CD-HU": "Haut-Uélé",
  "CD-IT": "Ituri",
  "CD-KC": "Kasaï Central",
  "CD-KE": "Kasaï-Oriental",
  "CD-KG": "Kwango",
  "CD-KL": "Kwilu",
  "CD-KN": "Kinshasa",
  "CD-KS": "Kasaï",
  "CD-KW": "Kasaï-Occidental",
  "CD-LO": "Lomami",
  "CD-LU": "Lualaba",
  "CD-MA": "Maniema",
  "CD-MN": "Mai-Ndombe",
  "CD-MO": "Mongala",
  "CD-NK": "North Kivu",
  "CD-NU": "Nord-Ubangi",
  "CD-SA": "Sankuru",
  "CD-SK": "South Kivu",
  "CD-SU": "Sud-Ubangi",
  "CD-TA": "Tanganyika",
  "CD-TU": "Tshuapa",
  "CF-AC": "Ouham",
  "CF-BB": "Bamingui-Bangoran",
  "CF-BGF": "Bangui",
  "CF-BK": "Basse-Kotto",
  "CF-HK": "Haute-Kotto",
  "CF-HM": "Haut-Mbomou",
  "CF-HS": "Mambéré-Kadéï",
  "CF-KB": "Nana-Grébizi",
  "CF-KG": "Kémo",
  "CF-LB": "Lobaye",
  "CF-MB": "Mbomou",
  "CF-MP": "Ombella-M’Poko",
  "CF-NM": "Nana-Mambéré",
  "CF-OP": "Ouham-Pendé",
  "CF-SE": "Sangha-Mbaéré",
  "CF-UK": "Ouaka",
  "CF-VK": "Vakaga",
  "CG-11": "Bouenza",
  "CG-12": "Pool",
  "CG-13": "Sangha",
  "CG-14": "Plateaux",
  "CG-15": "Cuvette-Ouest",
  "CG-16": "Pointe-Noire",
  "CG-2": "Lékoumou",
  "CG-5": "Kouilou",
  "CG-7": "Likouala",
  "CG-8": "Cuvette",
  "CG-9": "Niari",
  "CG-BZV": "Brazzaville",
  "CH-AG": "Aargau",
  "CH-AI": "Appenzell Innerrhoden",
  "CH-AR": "Appenzell Ausserrhoden",
  "CH-BE": "Bern",
  "CH-BL": "Basel-Landschaft",
  "CH-BS": "Basel-Stadt",
  "CH-FR": "Fribourg",
  "CH-GE": "Geneva",
  "CH-GL": "Glarus",
  "CH-GR": "Graubünden",
  "CH-JU": "Jura",
  "CH-LU": "Lucerne",
  "CH-NE": "Neuchâtel",
  "CH-NW": "Nidwalden",
  "CH-OW": "Obwalden",
  "CH-SG": "St. Gallen",
  "CH-SH": "Schaffhausen",
  "CH-SO": "Solothurn",
  "CH-SZ": "Schwyz",
  "CH-TG": "Thurgau",
  "CH-TI": "Ticino",
  "CH-UR": "Uri",
  "CH-VD": "Vaud",
  "CH-VS": "Valais",
  "CH-ZG": "Zug",
  "CH-ZH": "Zürich",
  "CI-AB": "Abidjan",
  "CI-BS": "Bas-Sassandra",
  "CI-CM": "Comoé",
  "CI-DN": "Denguélé",
  "CI-GD": "Gôh-Djiboua",
  "CI-LC": "Lacs",
  "CI-LG": "Lagunes",
  "CI-MG": "Montagnes",
  "CI-SM": "Sassandra-Marahoué",
  "CI-SV": "Savanes",
  "CI-VB": "Vallée du Bandama",
  "CI-WR": "Woroba",
  "CI-YM": "Yamoussoukro",
  "CI-ZZ": "Zanzan",
  "CL-AI": "Aysén",
  "CL-AN": "Antofagasta",
  "CL-AP": "Arica y Parinacota",
  "CL-AR": "Araucanía",
  "CL-AT": "Atacama",
  "CL-BI": "Bío Bío",
  "CL-CO": "Coquimbo",
  "CL-LI": "Libertador General Bernardo O’Higgins",
  "CL-LL": "Los Lagos",
  "CL-LR": "Los Ríos",
  "CL-MA": "Magallanes Region",
  "CL-ML": "Maule",
  "CL-NB": "Ñuble",
  "CL-RM": "Santiago Metropolitan",
  "CL-TA": "Tarapacá",
  "CL-VS": "Valparaíso",
  "CM-AD": "Adamawa",
  "CM-CE": "Centre",
  "CM-EN": "Far North",
  "CM-ES": "East",
  "CM-LT": "Littoral",
  "CM-NO": "North",
  "CM-NW": "Northwest",
  "CM-OU": "West",
  "CM-SU": "South",
  "CM-SW": "Southwest",
  "CN-AH": "Anhui",
  "CN-BJ": "Beijing",
  "CN-CQ": "Chongqing",
  "CN-FJ": "Fujian",
  "CN-GD": "Guangdong",
  "CN-GS": "Gansu",
  "CN-GX": "Guangxi",
  "CN-GZ": "Guizhou",
  "CN-HA": "Henan",
  "CN-HB": "Hubei",
  "CN-HE": "Hebei",
  "CN-HI": "Hainan",
  "CN-HL": "Heilongjiang",
  "CN-HN": "Hunan",
  "CN-JL": "Jilin",
  "CN-JS": "Jiangsu",
  "CN-JX": "Jiangxi",
  "CN-LN": "Liaoning",
  "CN-NX": "Ningxia",
  "CN-QH": "Qinghai",
  "CN-SC": "Sichuan",
  "CN-SD": "Shandong",
  "CN-SH": "Shanghai",
  "CN-SN": "Shaanxi",
  "CN-SX": "Shanxi",
  "CN-TJ": "Tianjin",
  "CN-XJ": "Xinjiang",
  "CN-XZ": "Tibet",
  "CN-YN": "Yunnan",
  "CN-ZJ": "Zhejiang",
  "CO-AMA": "Amazonas",
  "CO-ANT": "Antioquia",
  "CO-ARA": "Arauca",
  "CO-ATL": "Atlántico",
  "CO-BOL": "Bolívar",
  "CO-BOY": "Boyacá",
  "CO-CAL": "Caldas",
  "CO-CAQ": "Caquetá",
  "CO-CAS": "Casanare",
  "CO-CAU": "Cauca",
  "CO-CES": "Cesar",
  "CO-CHO": "Chocó",
  "CO-COR": "Córdoba",
  "CO-CUN": "Cundinamarca",
  "CO-DC": "Capital District",
  "CO-GUA": "Guainía",
  "CO-GUV": "Guaviare",
  "CO-HUI": "Huila",
  "CO-LAG": "La Guajira",
  "CO-MAG": "Magdalena",
  "CO-MET": "Meta",
  "CO-NAR": "Nariño",
  "CO-NSA": "Norte de Santander",
  "CO-PUT": "Putumayo",
  "CO-QUI": "Quindío",
  "CO-RIS": "Risaralda",
  "CO-SAN": "Santander",
  "CO-SAP": "San Andrés & Providencia",
  "CO-SUC": "Sucre",
  "CO-TOL": "Tolima",
  "CO-VAC": "Valle del Cauca",
  "CO-VAU": "Vaupés",
  "CO-VID": "Vichada",
  "CR-A": "Alajuela",
  "CR-C": "Cartago",
  "CR-G": "Guanacaste",
  "CR-H": "Heredia",
  "CR-L": "Limón",
  "CR-P": "Puntarenas",
  "CR-SJ": "San José",
  "CU-01": "Pinar del Río",
  "CU-03": "Havana",
  "CU-04": "Matanzas",
  "CU-05": "Villa Clara",
  "CU-06": "Cienfuegos",
  "CU-07": "Sancti Spíritus",
  "CU-08": "Ciego de Ávila",
  "CU-09": "Camagüey",
  "CU-10": "Las Tunas",
  "CU-11": "Holguín",
  "CU-12": "Granma",
  "CU-13": "Santiago de Cuba",
  "CU-14": "Guantánamo",
  "CU-15": "Artemisa",
  "CU-16": "Mayabeque",
  "CU-99": "Isla de la Juventud",
  "CV-B": "Barlavento Islands",
  "CV-BR": "Brava",
  "CV-BV": "Boa Vista",
  "CV-CA": "Santa Catarina",
  "CV-CF": "Santa Catarina do Fogo",
  "CV-CR": "Santa Cruz",
  "CV-MA": "Maio",
  "CV-MO": "Mosteiros",
  "CV-PA": "Paul",
  "CV-PN": "Porto Novo",
  "CV-PR": "Praia",
  "CV-RB": "Ribeira Brava",
  "CV-RG": "Ribeira Grande",
  "CV-RS": "Ribeira Grande de Santiago",
  "CV-SD": "São Domingos",
  "CV-SF": "São Filipe",
  "CV-SL": "Sal",
  "CV-SM": "São Miguel",
  "CV-SO": "São Lourenço dos Órgãos",
  "CV-SS": "São Salvador do Mundo",
  "CV-SV": "São Vicente",
  "CV-TA": "Tarrafal",
  "CY-01": "Nicosia",
  "CY-02": "Limassol",
  "CY-03": "Larnaca",
  "CY-04": "Famagusta",
  "CY-05": "Paphos",
  "CY-06": "Kyrenia",
  "CZ-10": "Prague, Hlavní mešto",
  "CZ-20": "Středočeský",
  "CZ-31": "Jihočeský",
  "CZ-32": "Plzeňský",
  "CZ-41": "Karlovarský",
  "CZ-42": "Ústecký",
  "CZ-51": "Liberecký",
  "CZ-52": "Královéhradecký",
  "CZ-53": "Pardubický",
  "CZ-63": "Vysočina",
  "CZ-64": "Jihomoravský",
  "CZ-71": "Olomoucký",
  "CZ-72": "Zlínský",
  "CZ-80": "Moravskoslezský",
  "DE-BB": "Brandenburg",
  "DE-BE": "Berlin",
  "DE-BW": "Baden-Württemberg",
  "DE-BY": "Bavaria",
  "DE-HB": "Bremen",
  "DE-HE": "Hesse",
  "DE-HH": "Hamburg",
  "DE-MV": "Mecklenburg-Vorpommern",
  "DE-NI": "Lower Saxony",
  "DE-NW": "North Rhine-Westphalia",
  "DE-RP": "Rhineland-Palatinate",
  "DE-SH": "Schleswig-Holstein",
  "DE-SL": "Saarland",
  "DE-SN": "Saxony",
  "DE-ST": "Saxony-Anhalt",
  "DE-TH": "Thuringia",
  "DJ-AR": "Arta",
  "DJ-AS": "Ali Sabieh",
  "DJ-DI": "Dikhil",
  "DJ-DJ": "Djibouti",
  "DJ-OB": "Obock",
  "DJ-TA": "Tadjourah",
  "DK-81": "Northern Denmark",
  "DK-82": "Central Denmark",
  "DK-83": "Southern Denmark",
  "DK-84": "Capital Region",
  "DK-85": "Zealand",
  "DO-01": "Distrito Nacional",
  "DO-02": "Azua",
  "DO-03": "Baoruco",
  "DO-04": "Barahona",
  "DO-05": "Dajabón",
  "DO-06": "Duarte",
  "DO-07": "Elías Piña",
  "DO-08": "El Seibo",
  "DO-09": "Espaillat",
  "DO-10": "Independencia",
  "DO-11": "La Altagracia",
  "DO-12": "La Romana",
  "DO-13": "La Vega",
  "DO-14": "María Trinidad Sánchez",
  "DO-15": "Monte Cristi",
  "DO-16": "Pedernales",
  "DO-17": "Peravia",
  "DO-18": "Puerto Plata",
  "DO-19": "Hermanas Mirabal",
  "DO-20": "Samaná",
  "DO-21": "San Cristóbal",
  "DO-22": "San Juan",
  "DO-23": "San Pedro de Macorís",
  "DO-24": "Sánchez Ramírez",
  "DO-25": "Santiago",
  "DO-26": "Santiago Rodríguez",
  "DO-27": "Valverde",
  "DO-28": "Monseñor Nouel",
  "DO-29": "Monte Plata",
  "DO-30": "Hato Mayor",
  "DO-31": "San José de Ocoa",
  "DO-32": "Santo Domingo",
  "DZ-01": "Adrar",
  "DZ-02": "Chlef",
  "DZ-03": "Laghouat",
  "DZ-04": "Oum El Bouaghi",
  "DZ-05": "Batna",
  "DZ-06": "Béjaïa",
  "DZ-07": "Biskra",
  "DZ-08": "Béchar",
  "DZ-09": "Blida",
  "DZ-10": "Bouira",
  "DZ-11": "Tamanghasset",
  "DZ-12": "Tébessa",
  "DZ-13": "Tlemcen",
  "DZ-14": "Tiaret",
  "DZ-15": "Tizi Ouzou",
  "DZ-16": "Algiers",
  "DZ-17": "Djelfa",
  "DZ-18": "Jijel",
  "DZ-19": "Sétif",
  "DZ-20": "Saïda",
  "DZ-21": "Skikda",
  "DZ-22": "Sidi Bel Abbès",
  "DZ-23": "Annaba",
  "DZ-24": "Guelma",
  "DZ-25": "Constantine",
  "DZ-26": "Médéa",
  "DZ-27": "Mostaganem",
  "DZ-28": "M’Sila",
  "DZ-29": "Mascara",
  "DZ-30": "Ouargla",
  "DZ-31": "Oran",
  "DZ-32": "El Bayadh",
  "DZ-33": "Illizi",
  "DZ-34": "Bordj Bou Arréridj",
  "DZ-35": "Boumerdès",
  "DZ-36": "El Tarf",
  "DZ-37": "Tindouf",
  "DZ-38": "Tissemsilt",
  "DZ-39": "El Oued",
  "DZ-40": "Khenchela",
  "DZ-41": "Souk Ahras",
  "DZ-42": "Tipasa",
  "DZ-43": "Mila",
  "DZ-44": "Aïn Defla",
  "DZ-45": "Naama",
  "DZ-46": "Aïn Témouchent",
  "DZ-47": "Ghardaïa",
  "DZ-48": "Relizane",
  "DZ-49": "Timimoun",
  "DZ-50": "Bordj Badji Mokhtar",
  "DZ-51": "Ouled Djellal",
  "DZ-52": "Béni Abbès",
  "DZ-53": "In Salah",
  "DZ-54": "In Guezzam",
  "DZ-55": "Touggourt",
  "DZ-56": "Djanet",
  "DZ-57": "El Meghaier",
  "DZ-58": "El Meniaa",
  "EC-A": "Azuay",
  "EC-B": "Bolívar",
  "EC-C": "Carchi",
  "EC-D": "Orellana",
  "EC-E": "Esmeraldas",
  "EC-F": "Cañar",
  "EC-G": "Guayas",
  "EC-H": "Chimborazo",
  "EC-I": "Imbabura",
  "EC-L": "Loja",
  "EC-M": "Manabí",
  "EC-N": "Napo",
  "EC-O": "El Oro",
  "EC-P": "Pichincha",
  "EC-R": "Los Ríos",
  "EC-S": "Morona-Santiago",
  "EC-SD": "Santo Domingo de los Tsáchilas",
  "EC-SE": "Santa Elena",
  "EC-T": "Tungurahua",
  "EC-U": "Sucumbíos",
  "EC-W": "Galápagos",
  "EC-X": "Cotopaxi",
  "EC-Y": "Pastaza",
  "EC-Z": "Zamora-Chinchipe",
  "EE-37": "Harju",
  "EE-39": "Hiiu",
  "EE-44": "Ida-Viru",
  "EE-57": "Lääne",
  "EE-59": "Lääne-Viru",
  "EE-74": "Saare",
  "EE-84": "Viljandi",
  "EG-ALX": "Alexandria",
  "EG-ASN": "Aswan",
  "EG-AST": "Asyut",
  "EG-BA": "Red Sea",
  "EG-BH": "Beheira",
  "EG-BNS": "Beni Suef",
  "EG-C": "Cairo",
  "EG-DK": "Dakahlia",
  "EG-DT": "Damietta",
  "EG-FYM": "Faiyum",
  "EG-GH": "Gharbia",
  "EG-GZ": "Giza",
  "EG-IS": "Ismailia",
  "EG-JS": "South Sinai",
  "EG-KB": "Qalyubia",
  "EG-KFS": "Kafr el-Sheikh",
  "EG-KN": "Qena",
  "EG-LX": "Luxor",
  "EG-MN": "Minya",
  "EG-MNF": "Monufia",
  "EG-MT": "Matrouh",
  "EG-PTS": "Port Said",
  "EG-SHG": "Sohag",
  "EG-SHR": "Al Sharqia",
  "EG-SIN": "North Sinai",
  "EG-SUZ": "Suez",
  "EG-WAD": "New Valley",
  "ER-AN": "Anseba",
  "ER-DK": "Southern Red Sea",
  "ER-DU": "Debub",
  "ER-GB": "Gash-Barka",
  "ER-MA": "Maekel",
  "ER-SK": "Northern Red Sea",
  "ES-AN": "Andalusia",
  "ES-AR": "Aragon",
  "ES-AS": "Asturias",
  "ES-CB": "Cantabria",
  "ES-CE": "Ceuta",
  "ES-CL": "Castile and León",
  "ES-CM": "Castile-La Mancha",
  "ES-CN": "Canary Islands",
  "ES-CT": "Catalonia",
  "ES-EX": "Extremadura",
  "ES-GA": "Galicia",
  "ES-IB": "Balearic Islands",
  "ES-MC": "Murcia Region",
  "ES-MD": "Madrid Autonomous Community",
  "ES-ML": "Melilla",
  "ES-NC": "Navarra Chartered Community",
  "ES-PV": "Basque Country",
  "ES-RI": "La Rioja",
  "ES-VC": "Valencian Community",
  "ET-AA": "Addis Ababa",
  "ET-AF": "Afar",
  "ET-AM": "Amhara",
  "ET-BE": "Benishangul-Gumuz",
  "ET-DD": "Dire Dawa",
  "ET-GA": "Gambela",
  "ET-HA": "Harari",
  "ET-OR": "Oromia",
  "ET-SI": "Sidama",
  "ET-SN": "Southern Nations, Nationalities, and Peoples",
  "ET-SO": "Somali",
  "ET-TI": "Tigray",
  "FI-02": "South Karelia",
  "FI-04": "Southern Savonia",
  "FI-05": "Kainuu",
  "FI-06": "Tavastia Proper",
  "FI-07": "Central Ostrobothnia",
  "FI-08": "Central Finland",
  "FI-09": "Kymenlaakso",
  "FI-10": "Lapland",
  "FI-11": "Pirkanmaa",
  "FI-12": "Ostrobothnia",
  "FI-13": "North Karelia",
  "FI-14": "Northern Ostrobothnia",
  "FI-15": "Northern Savonia",
  "FI-16": "Päijänne Tavastia",
  "FI-17": "Satakunta",
  "FI-18": "Uusimaa",
  "FI-19": "Southwest Finland",
  "FJ-C": "Central",
  "FJ-E": "Eastern",
  "FJ-N": "Northern",
  "FJ-R": "Rotuma",
  "FJ-W": "Western",
  "FM-KSA": "Kosrae",
  "FM-PNI": "Pohnpei",
  "FM-TRK": "Chuuk",
  "FM-YAP": "Yap",
  "FR-20R": "Corse",
  "FR-971": "Guadeloupe",
  "FR-972": "Martinique",
  "FR-973": "Guyane (française)",
  "FR-974": "La Réunion",
  "FR-976": "Mayotte",
  "FR-ARA": "Auvergne-Rhône-Alpes",
  "FR-BFC": "Burgundy-Franche-Comté",
  "FR-BRE": "Brittany",
  "FR-CVL": "Centre-Val de Loire",
  "FR-GES": "Grand-Est",
  "FR-HDF": "Hauts-de-France",
  "FR-IDF": "Île-de-France",
  "FR-NAQ": "Nouvelle-Aquitaine",
  "FR-NOR": "Normandie",
  "FR-OCC": "Occitanie",
  "FR-PAC": "Provence-Alpes-Côte-d’Azur",
  "FR-PDL": "Pays-de-la-Loire",
  "GA-1": "Estuaire",
  "GA-2": "Haut-Ogooué",
  "GA-3": "Moyen-Ogooué",
  "GA-4": "Ngounié",
  "GA-5": "Nyanga",
  "GA-6": "Ogooué-Ivindo",
  "GA-7": "Ogooué-Lolo",
  "GA-8": "Ogooué-Maritime",
  "GA-9": "Woleu-Ntem",
  "GB-ENG": "England",
  "GB-NIR": "Northern Ireland",
  "GB-SCT": "Scotland",
  "GB-WLS": "Wales",
  "GE-AB": "Abkhazia",
  "GE-AJ": "Adjara",
  "GE-GU": "Guria",
  "GE-IM": "Imereti",
  "GE-KA": "Kakheti",
  "GE-KK": "Kvemo Kartli",
  "GE-MM": "Mtskheta-Mtianeti",
  "GE-RL": "Racha-Lechkhumi and Kvemo Svaneti",
  "GE-SJ": "Samtskhe-Javakheti",
  "GE-SK": "Shida Kartli",
  "GE-SZ": "Samegrelo-Zemo Svaneti",
  "GE-TB": "Tbilisi",
  "GH-AA": "Greater Accra",
  "GH-AF": "Ahafo",
  "GH-AH": "Ashanti",
  "GH-BA": "Brong-Ahafo",
  "GH-BE": "Bono East",
  "GH-BO": "Bono",
  "GH-CP": "Central",
  "GH-EP": "Eastern",
  "GH-NE": "North East",
  "GH-NP": "Northern",
  "GH-OT": "Oti",
  "GH-SV": "Savannah",
  "GH-TV": "Volta",
  "GH-UE": "Upper East",
  "GH-UW": "Upper West",
  "GH-WP": "Western",
  "GM-B": "Banjul",
  "GM-L": "Lower River Division",
  "GM-M": "Central River Division",
  "GM-N": "North Bank Division",
  "GM-U": "Upper River Division",
  "GM-W": "West Coast Division",
  "GN-B": "Boké Region",
  "GN-C": "Conakry",
  "GN-D": "Kindia Region",
  "GN-F": "Faranah Region",
  "GN-K": "Kankan Region",
  "GN-L": "Labé Region",
  "GN-M": "Mamou Region",
  "GN-N": "Nzérékoré Region",
  "GQ-AN": "Annobón",
  "GQ-BN": "Bioko Norte",
  "GQ-BS": "Bioko Sur",
  "GQ-C": "Río Muni",
  "GQ-CS": "Centro Sur",
  "GQ-DJ": "Djibloho",
  "GQ-KN": "Kié-Ntem",
  "GQ-LI": "Litoral",
  "GQ-WN": "Wele-Nzas",
  "GR-A": "East Macedonia and Thrace",
  "GR-B": "Central Macedonia",
  "GR-C": "West Macedonia",
  "GR-D": "Epirus",
  "GR-E": "Thessaly",
  "GR-F": "Ionian Islands",
  "GR-G": "West Greece",
  "GR-H": "Central Greece",
  "GR-I": "Attica",
  "GR-J": "Peloponnese",
  "GR-K": "North Aegean",
  "GR-L": "South Aegean",
  "GR-M": "Crete",
  "GW-BA": "Bafatá",
  "GW-BL": "Bolama",
  "GW-BM": "Biombo",
  "GW-BS": "Bissau",
  "GW-CA": "Cacheu",
  "GW-GA": "Gabú",
  "GW-OI": "Oio",
  "GW-QU": "Quinara",
  "GW-TO": "Tombali",
  "GY-BA": "Barima-Waini",
  "GY-CU": "Cuyuni-Mazaruni",
  "GY-DE": "Demerara-Mahaica",
  "GY-EB": "East Berbice-Corentyne",
  "GY-ES": "Essequibo Islands-West Demerara",
  "GY-MA": "Mahaica-Berbice",
  "GY-PM": "Pomeroon-Supenaam",
  "GY-PT": "Potaro-Siparuni",
  "GY-UD": "Upper Demerara-Berbice",
  "GY-UT": "Upper Takutu-Upper Essequibo",
  "HN-AT": "Atlántida",
  "HN-CH": "Choluteca",
  "HN-CL": "Colón",
  "HN-CM": "Comayagua",
  "HN-CP": "Copán",
  "HN-CR": "Cortés",
  "HN-EP": "El Paraíso",
  "HN-FM": "Francisco Morazán",
  "HN-GD": "Gracias a Dios",
  "HN-IB": "Bay Islands",
  "HN-IN": "Intibucá",
  "HN-LE": "Lempira",
  "HN-LP": "La Paz",
  "HN-OC": "Ocotepeque",
  "HN-OL": "Olancho",
  "HN-SB": "Santa Bárbara",
  "HN-VA": "Valle",
  "HN-YO": "Yoro",
  "HR-01": "Zagreb County",
  "HR-02": "Krapina-Zagorje",
  "HR-03": "Sisak-Moslavina",
  "HR-04": "Karlovac",
  "HR-05": "Varaždin",
  "HR-06": "Koprivnica-Križevci",
  "HR-07": "Bjelovar-Bilogora",
  "HR-08": "Primorje-Gorski Kotar",
  "HR-09": "Lika-Senj",
  "HR-10": "Virovitica-Podravina",
  "HR-11": "Požega-Slavonia",
  "HR-12": "Brod-Posavina",
  "HR-13": "Zadar",
  "HR-14": "Osijek-Baranja",
  "HR-15": "Šibenik-Knin",
  "HR-16": "Vukovar-Syrmia",
  "HR-17": "Split-Dalmatia",
  "HR-18": "Istria",
  "HR-19": "Dubrovnik-Neretva",
  "HR-20": "Međimurje",
  "HR-21": "Zagreb",
  "HT-AR": "Artibonite",
  "HT-CE": "Centre",
  "HT-GA": "Grand’Anse",
  "HT-ND": "Nord",
  "HT-NE": "Nord-Est",
  "HT-NI": "Nippes",
  "HT-NO": "Nord-Ouest",
  "HT-OU": "Ouest",
  "HT-SD": "Sud",
  "HT-SE": "Sud-Est",
  "HU-BA": "Baranya",
  "HU-BC": "Békéscsaba",
  "HU-BE": "Békés",
  "HU-BK": "Bács-Kiskun",
  "HU-BU": "Budapest",
  "HU-BZ": "Borsod-Abaúj-Zemplén",
  "HU-CS": "Csongrád",
  "HU-FE": "Fejér",
  "HU-GS": "Győr-Moson-Sopron",
  "HU-HB": "Hajdú-Bihar",
  "HU-HE": "Heves",
  "HU-JN": "Jász-Nagykun-Szolnok",
  "HU-KE": "Komárom-Esztergom",
  "HU-NO": "Nógrád",
  "HU-PE": "Pest",
  "HU-SO": "Somogy",
  "HU-SZ": "Szabolcs-Szatmár-Bereg",
  "HU-TO": "Tolna",
  "HU-VA": "Vas",
  "HU-VE": "Veszprém County",
  "HU-ZA": "Zala",
  "ID-AC": "Aceh",
  "ID-BA": "Bali",
  "ID-BB": "Bangka–Belitung Islands",
  "ID-BE": "Bengkulu",
  "ID-BT": "Banten",
  "ID-GO": "Gorontalo",
  "ID-JA": "Jambi",
  "ID-JB": "West Java",
  "ID-JI": "East Java",
  "ID-JK": "Jakarta",
  "ID-JT": "Central Java",
  "ID-JW": "Java",
  "ID-KA": "Kalimantan",
  "ID-KB": "West Kalimantan",
  "ID-KI": "East Kalimantan",
  "ID-KR": "Riau Islands",
  "ID-KS": "South Kalimantan",
  "ID-KT": "Central Kalimantan",
  "ID-KU": "North Kalimantan",
  "ID-LA": "Lampung",
  "ID-MA": "Maluku",
  "ID-MU": "North Maluku",
  "ID-NB": "West Nusa Tenggara",
  "ID-NT": "East Nusa Tenggara",
  "ID-PA": "Papua",
  "ID-PB": "West Papua",
  "ID-PE": "Papua Pengunungan",
  "ID-RI": "Riau",
  "ID-SA": "North Sulawesi",
  "ID-SB": "West Sumatra",
  "ID-SG": "Southeast Sulawesi",
  "ID-SN": "South Sulawesi",
  "ID-SR": "West Sulawesi",
  "ID-SS": "South Sumatra",
  "ID-ST": "Central Sulawesi",
  "ID-SU": "North Sumatra",
  "ID-YO": "Yogyakarta",
  "IE-C": "Connacht",
  "IE-CE": "Clare",
  "IE-CN": "Cavan",
  "IE-CO": "Cork",
  "IE-CW": "Carlow",
  "IE-D": "Dublin",
  "IE-DL": "Donegal",
  "IE-G": "Galway",
  "IE-KE": "Kildare",
  "IE-KK": "Kilkenny",
  "IE-KY": "Kerry",
  "IE-L": "Leinster",
  "IE-LD": "Longford",
  "IE-LH": "Louth",
  "IE-LK": "Limerick",
  "IE-LM": "Leitrim",
  "IE-LS": "Laois",
  "IE-MH": "Meath",
  "IE-MN": "Monaghan",
  "IE-MO": "Mayo",
  "IE-OY": "Offaly",
  "IE-RN": "Roscommon",
  "IE-SO": "Sligo",
  "IE-WD": "Waterford",
  "IE-WH": "Westmeath",
  "IE-WW": "Wicklow",
  "IE-WX": "Wexford",
  "IL-D": "Southern District",
  "IL-HA": "Haifa District",
  "IL-JM": "Jerusalem",
  "IL-M": "Central District",
  "IL-TA": "Tel Aviv District",
  "IL-Z": "Northern District",
  "IN-AN": "Andaman and Nicobar Islands",
  "IN-AP": "Andhra Pradesh",
  "IN-AR": "Arunachal Pradesh",
  "IN-AS": "Assam",
  "IN-BR": "Bihar",
  "IN-CG": "Chhattīsgarh",
  "IN-CH": "Chandigarh",
  "IN-DD": "Daman and Diu",
  "IN-DH": "Dādra and Nagar Haveli and Damān and Diu",
  "IN-DL": "Delhi",
  "IN-GA": "Goa",
  "IN-GJ": "Gujarat",
  "IN-HP": "Himachal Pradesh",
  "IN-HR": "Haryana",
  "IN-JH": "Jharkhand",
  "IN-JK": "Jammu and Kashmir",
  "IN-KA": "Karnataka",
  "IN-KL": "Kerala",
  "IN-LA": "Ladakh",
  "IN-LD": "Lakshadweep",
  "IN-MH": "Maharashtra",
  "IN-ML": "Meghalaya",
  "IN-MN": "Manipur",
  "IN-MP": "Madhya Pradesh",
  "IN-MZ": "Mizoram",
  "IN-NL": "Nagaland",
  "IN-OD": "Odisha",
  "IN-PB": "Punjab",
  "IN-PY": "Puducherry",
  "IN-RJ": "Rajasthan",
  "IN-SK": "Sikkim",
  "IN-TN": "Tamil Nadu",
  "IN-TR": "Tripura",
  "IN-TS": "Telangāna",
  "IN-UK": "Uttarākhand",
  "IN-UP": "Uttar Pradesh",
  "IN-WB": "West Bengal",
  "IQ-AN": "Al Anbar",
  "IQ-AR": "Erbil",
  "IQ-BA": "Basra",
  "IQ-BB": "Babylon",
  "IQ-BG": "Baghdad",
  "IQ-DA": "Dohuk",
  "IQ-DI": "Diyala",
  "IQ-DQ": "Dhi Qar",
  "IQ-KA": "Karbala",
  "IQ-KI": "Kirkuk",
  "IQ-MA": "Maysan",
  "IQ-MU": "Al Muthanna",
  "IQ-NA": "Najaf",
  "IQ-NI": "Nineveh",
  "IQ-QA": "Al-Qādisiyyah",
  "IQ-SD": "Saladin",
  "IQ-SU": "Sulaymaniyah",
  "IQ-WA": "Wasit",
  "IR-00": "Markazī",
  "IR-01": "East Azerbaijan",
  "IR-02": "West Azarbaijan",
  "IR-03": "Ardabil",
  "IR-04": "Isfahan",
  "IR-05": "Ilam",
  "IR-06": "Bushehr",
  "IR-07": "Tehran",
  "IR-08": "Chaharmahal and Bakhtiari",
  "IR-09": "Khorāsān-e Raẕavī",
  "IR-10": "Khuzestan",
  "IR-11": "Zanjan",
  "IR-12": "Semnan",
  "IR-13": "Sistan and Baluchestan",
  "IR-14": "Fars",
  "IR-15": "Kerman",
  "IR-16": "Kurdistan",
  "IR-17": "Kermanshah",
  "IR-18": "Kohgiluyeh and Boyer-Ahmad",
  "IR-19": "Gilan",
  "IR-20": "Lorestan",
  "IR-21": "Mazandaran",
  "IR-22": "Markazi",
  "IR-23": "Hormozgan",
  "IR-24": "Hamadan",
  "IR-25": "Yazd",
  "IR-26": "Qom",
  "IR-27": "Golestan",
  "IR-28": "Qazvin",
  "IR-29": "South Khorasan",
  "IR-30": "Razavi Khorasan",
  "IR-31": "North Khorasan",
  "IR-32": "Alborz",
  "IS-1": "Capital",
  "IS-2": "Southern Peninsula",
  "IS-3": "Western",
  "IS-4": "Westfjords",
  "IS-5": "Northwestern",
  "IS-6": "Northeastern",
  "IS-7": "Eastern",
  "IS-8": "Southern",
  "IT-21": "Piedmont",
  "IT-23": "Aosta Valley",
  "IT-25": "Lombardy",
  "IT-32": "Trentino-South Tyrol",
  "IT-34": "Veneto",
  "IT-36": "Friuli–Venezia Giulia",
  "IT-42": "Liguria",
  "IT-45": "Emilia-Romagna",
  "IT-52": "Tuscany",
  "IT-55": "Umbria",
  "IT-57": "Marche",
  "IT-62": "Lazio",
  "IT-65": "Abruzzo",
  "IT-67": "Molise",
  "IT-72": "Campania",
  "IT-75": "Apulia",
  "IT-77": "Basilicata",
  "IT-78": "Calabria",
  "IT-82": "Sicily",
  "IT-88": "Sardinia",
  "JM-01": "Kingston",
  "JM-02": "Saint Andrew",
  "JM-03": "Saint Thomas",
  "JM-04": "Portland",
  "JM-05": "Saint Mary",
  "JM-06": "Saint Ann",
  "JM-07": "Trelawny",
  "JM-08": "Saint James",
  "JM-09": "Hanover",
  "JM-10": "Westmoreland",
  "JM-11": "Saint Elizabeth",
  "JM-12": "Manchester",
  "JM-13": "Clarendon",
  "JM-14": "Saint Catherine",
  "JO-AJ": "Ajloun",
  "JO-AM": "Amman",
  "JO-AQ": "Aqaba",
  "JO-AT": "Tafilah",
  "JO-AZ": "Zarqa",
  "JO-BA": "Balqa",
  "JO-IR": "Irbid",
  "JO-JA": "Jerash",
  "JO-KA": "Karak",
  "JO-MA": "Mafraq",
  "JO-MD": "Madaba",
  "JO-MN": "Ma’an",
  "JP-01": "Hokkaidō",
  "JP-02": "Aomori",
  "JP-03": "Iwate",
  "JP-04": "Miyagi",
  "JP-05": "Akita",
  "JP-06": "Yamagata",
  "JP-07": "Fukushima",
  "JP-08": "Ibaraki",
  "JP-09": "Tochigi",
  "JP-10": "Gunma",
  "JP-11": "Saitama",
  "JP-12": "Chiba",
  "JP-13": "Tokyo",
  "JP-14": "Kanagawa",
  "JP-15": "Niigata",
  "JP-16": "Toyama",
  "JP-17": "Ishikawa",
  "JP-18": "Fukui",
  "JP-19": "Yamanashi",
  "JP-20": "Nagano",
  "JP-21": "Gifu",
  "JP-22": "Shizuoka",
  "JP-23": "Aichi",
  "JP-24": "Mie",
  "JP-25": "Shiga",
  "JP-26": "Kyōto",
  "JP-27": "Ōsaka",
  "JP-28": "Hyōgo",
  "JP-29": "Nara",
  "JP-30": "Wakayama",
  "JP-31": "Tottori",
  "JP-32": "Shimane",
  "JP-33": "Okayama",
  "JP-34": "Hiroshima",
  "JP-35": "Yamaguchi",
  "JP-36": "Tokushima",
  "JP-37": "Kagawa",
  "JP-38": "Ehime",
  "JP-39": "Kōchi",
  "JP-40": "Fukuoka",
  "JP-41": "Saga",
  "JP-42": "Nagasaki",
  "JP-43": "Kumamoto",
  "JP-44": "Ōita",
  "JP-45": "Miyazaki",
  "JP-46": "Kagoshima",
  "JP-47": "Okinawa",
  "KE-01": "Baringo",
  "KE-02": "Bomet",
  "KE-03": "Bungoma",
  "KE-04": "Busia",
  "KE-05": "Elgeyo-Marakwet",
  "KE-06": "Embu",
  "KE-07": "Garissa",
  "KE-08": "Homa Bay",
  "KE-09": "Isiolo",
  "KE-10": "Kajiado",
  "KE-11": "Kakamega",
  "KE-12": "Kericho",
  "KE-13": "Kiambu",
  "KE-14": "Kilifi",
  "KE-15": "Kirinyaga",
  "KE-16": "Kisii",
  "KE-17": "Kisumu",
  "KE-18": "Kitui",
  "KE-19": "Kwale",
  "KE-20": "Laikipia",
  "KE-21": "Lamu",
  "KE-22": "Machakos",
  "KE-23": "Makueni",
  "KE-24": "Mandera",
  "KE-25": "Marsabit",
  "KE-26": "Meru",
  "KE-27": "Migori",
  "KE-28": "Mombasa",
  "KE-29": "Murang’a",
  "KE-30": "Nairobi County",
  "KE-31": "Nakuru",
  "KE-32": "Nandi",
  "KE-33": "Narok",
  "KE-34": "Nyamira",
  "KE-35": "Nyandarua",
  "KE-36": "Nyeri",
  "KE-37": "Samburu",
  "KE-38": "Siaya",
  "KE-39": "Taita-Taveta",
  "KE-40": "Tana River",
  "KE-41": "Tharaka-Nithi",
  "KE-42": "Trans Nzoia",
  "KE-43": "Turkana",
  "KE-44": "Uasin Gishu",
  "KE-45": "Vihiga",
  "KE-46": "Wajir",
  "KE-47": "West Pokot",
  "KG-B": "Batken",
  "KG-C": "Chuy",
  "KG-GB": "Bishkek",
  "KG-GO": "Osh",
  "KG-J": "Jalal-Abad",
  "KG-N": "Naryn",
  "KG-O": "Osh Region",
  "KG-T": "Talas",
  "KG-Y": "Issyk-Kul",
  "KH-1": "Banteay Meanchey",
  "KH-10": "Kratié",
  "KH-11": "Mondulkiri",
  "KH-12": "Phnom Penh",
  "KH-13": "Preah Vihear",
  "KH-14": "Prey Veng",
  "KH-15": "Pursat",
  "KH-16": "Ratanakiri",
  "KH-17": "Siem Reap",
  "KH-18": "Sihanoukville",
  "KH-19": "Stung Treng",
  "KH-2": "Battambang",
  "KH-20": "Svay Rieng",
  "KH-21": "Takéo",
  "KH-22": "Oddar Meanchey",
  "KH-23": "Kep",
  "KH-24": "Pailin",
  "KH-25": "Tbong Khmum",
  "KH-3": "Kampong Cham",
  "KH-4": "Kampong Chhnang",
  "KH-5": "Kampong Speu",
  "KH-6": "Kampong Thom",
  "KH-7": "Kampot",
  "KH-8": "Kandal",
  "KH-9": "Koh Kong",
  "KI-G": "Gilbert Islands",
  "KI-L": "Line Islands",
  "KI-P": "Phoenix Islands",
  "KM-A": "Anjouan",
  "KM-G": "Grande Comore",
  "KM-M": "Mohéli",
  "KR-11": "Seoul",
  "KR-26": "Busan",
  "KR-27": "Daegu",
  "KR-28": "Incheon",
  "KR-29": "Gwangju City",
  "KR-30": "Daejeon",
  "KR-31": "Ulsan",
  "KR-41": "Gyeonggi",
  "KR-42": "Gangwon",
  "KR-43": "North Chungcheong",
  "KR-44": "South Chungcheong",
  "KR-45": "North Jeolla",
  "KR-46": "South Jeolla",
  "KR-47": "North Gyeongsang",
  "KR-48": "South Gyeongsang",
  "KR-49": "Jeju",
  "KR-50": "Sejong",
  "KW-AH": "Al Ahmadi",
  "KW-FA": "Al Farwaniyah",
  "KW-HA": "Hawalli",
  "KW-JA": "Al Jahra",
  "KW-KU": "Al Asimah",
  "KW-MU": "Mubarak Al-Kabeer",
  "KZ-AKM": "Akmola",
  "KZ-AKT": "Aktobe",
  "KZ-ALM": "Almaty Region",
  "KZ-ATY": "Atyrau",
  "KZ-BAY": "Bayqongyr",
  "KZ-KAR": "Karagandy",
  "KZ-KUS": "Kostanay",
  "KZ-KZY": "Kyzylorda",
  "KZ-MAN": "Mangystau",
  "KZ-PAV": "Pavlodar",
  "KZ-SEV": "North Kazakhstan",
  "KZ-VOS": "East Kazakhstan",
  "KZ-YUZ": "South Kazakhstan",
  "KZ-ZAP": "West Kazakhstan",
  "KZ-ZHA": "Jambyl",
  "LA-AT": "Attapeu",
  "LA-BK": "Bokeo",
  "LA-BL": "Bolikhamsai",
  "LA-CH": "Champasak",
  "LA-HO": "Houaphanh",
  "LA-KH": "Khammouane",
  "LA-LM": "Luang Namtha",
  "LA-LP": "Luang Prabang",
  "LA-OU": "Oudomxay",
  "LA-PH": "Phongsaly",
  "LA-SL": "Salavan",
  "LA-SV": "Savannakhet",
  "LA-VI": "Vientiane Province",
  "LA-VT": "Vientiane",
  "LA-XA": "Sainyabuli",
  "LA-XE": "Sekong",
  "LA-XI": "Xiangkhouang",
  "LB-AK": "Akkar",
  "LB-AS": "North",
  "LB-BA": "Beirut",
  "LB-BH": "Baalbek-Hermel",
  "LB-BI": "Beqaa",
  "LB-JA": "South",
  "LB-JL": "Mount Lebanon",
  "LB-NA": "Nabatieh",
  "LI-01": "Balzers",
  "LI-02": "Eschen",
  "LI-03": "Gamprin",
  "LI-04": "Mauren",
  "LI-05": "Planken",
  "LI-06": "Ruggell",
  "LI-07": "Schaan",
  "LI-08": "Schellenberg",
  "LI-09": "Triesen",
  "LI-10": "Triesenberg",
  "LI-11": "Vaduz",
  "LK-1": "Western",
  "LK-2": "Central",
  "LK-3": "Southern",
  "LK-4": "Northern",
  "LK-5": "Eastern",
  "LK-6": "North Western",
  "LK-7": "North Central",
  "LK-8": "Uva",
  "LK-9": "Sabaragamuwa",
  "LR-BG": "Bong",
  "LR-BM": "Bomi",
  "LR-CM": "Grand Cape Mount",
  "LR-GB": "Grand Bassa",
  "LR-GG": "Grand Gedeh",
  "LR-GK": "Grand Kru",
  "LR-GP": "Gbarpolu",
  "LR-LO": "Lofa",
  "LR-MG": "Margibi",
  "LR-MO": "Montserrado",
  "LR-MY": "Maryland",
  "LR-NI": "Nimba",
  "LR-RG": "River Gee",
  "LR-RI": "Rivercess",
  "LR-SI": "Sinoe",
  "LS-A": "Maseru",
  "LS-B": "Butha-Buthe",
  "LS-C": "Leribe",
  "LS-D": "Berea",
  "LS-E": "Mafeteng",
  "LS-F": "Mohale’s Hoek",
  "LS-G": "Quthing",
  "LS-H": "Qacha’s Nek",
  "LS-J": "Mokhotlong",
  "LS-K": "Thaba-Tseka",
  "LT-AL": "Alytus County",
  "LT-KL": "Klaipėda County",
  "LT-KU": "Kaunas County",
  "LT-MR": "Marijampolė County",
  "LT-PN": "Panevėžys County",
  "LT-SA": "Šiauliai County",
  "LT-TA": "Tauragė County",
  "LT-TE": "Telšiai County",
  "LT-UT": "Utena County",
  "LT-VL": "Vilnius County",
  "LU-CA": "Capellen",
  "LU-CL": "Clervaux",
  "LU-DI": "Diekirch",
  "LU-EC": "Echternach",
  "LU-ES": "Esch-sur-Alzette",
  "LU-GR": "Grevenmacher",
  "LU-LU": "Luxembourg",
  "LU-ME": "Mersch",
  "LU-RD": "Redange",
  "LU-RM": "Remich",
  "LU-VD": "Vianden",
  "LU-WI": "Wiltz",
  "LV-001": "Aglona",
  "LV-002": "Aizkraukle",
  "LV-003": "Aizpute",
  "LV-004": "Aknīste",
  "LV-005": "Aloja",
  "LV-006": "Alsunga",
  "LV-007": "Alūksne",
  "LV-008": "Amata",
  "LV-009": "Ape",
  "LV-010": "Auce",
  "LV-011": "Ādaži",
  "LV-012": "Babīte",
  "LV-013": "Baldone",
  "LV-014": "Baltinava",
  "LV-015": "Balvi",
  "LV-016": "Bauska",
  "LV-017": "Beverīna",
  "LV-018": "Brocēni",
  "LV-019": "Burtnieki",
  "LV-020": "Carnikava",
  "LV-021": "Cesvaine",
  "LV-022": "Cēsis",
  "LV-023": "Cibla",
  "LV-024": "Dagda",
  "LV-025": "Daugavpils Municipality",
  "LV-026": "Dobele",
  "LV-027": "Dundaga",
  "LV-028": "Durbe",
  "LV-029": "Engure",
  "LV-030": "Ērgļi",
  "LV-031": "Garkalne",
  "LV-032": "Grobiņa",
  "LV-033": "Gulbene",
  "LV-034": "Iecava",
  "LV-035": "Ikšķile",
  "LV-036": "Ilūkste",
  "LV-037": "Inčukalns",
  "LV-038": "Jaunjelgava",
  "LV-039": "Jaunpiebalga",
  "LV-040": "Jaunpils",
  "LV-041": "Jelgava Municipality",
  "LV-042": "Jēkabpils Municipality",
  "LV-DGV": "Daugavpils",
  "LV-JEL": "Jelgava",
  "LV-JUR": "Jūrmala",
  "LV-LPX": "Liepāja",
  "LV-REZ": "Rēzekne",
  "LV-RIX": "Riga",
  "LV-VEN": "Ventspils",
  "LV-VMR": "Valmiera",
  "LY-BA": "Benghazi",
  "LY-BU": "Butnan",
  "LY-DR": "Derna",
  "LY-GT": "Ghat",
  "LY-JA": "Jabal al Akhdar",
  "LY-JG": "Jabal al Gharbi",
  "LY-JI": "Jafara",
  "LY-JU": "Jufra",
  "LY-KF": "Kufra",
  "LY-MB": "Murqub",
  "LY-MI": "Misrata",
  "LY-MJ": "Marj",
  "LY-MQ": "Murzuq",
  "LY-NL": "Nalut",
  "LY-NQ": "Nuqat al Khams",
  "LY-SB": "Sabha",
  "LY-SR": "Sirte",
  "LY-TB": "Tripoli",
  "LY-WA": "Al Wahat",
  "LY-WD": "Wadi al Hayaa",
  "LY-WS": "Wadi al Shatii",
  "LY-ZA": "Zawiya",
  "MA-01": "Tangier-Tétouan",
  "MA-02": "Gharb-Chrarda-Béni Hssen",
  "MA-03": "Taza-Al Hoceima-Taounate",
  "MA-04": "Oriental",
  "MA-05": "Fès-Boulemane",
  "MA-06": "Meknès-Tafilalet",
  "MA-07": "Rabat-Salé-Zemmour-Zaer",
  "MA-08": "Grand Casablanca",
  "MA-09": "Chaouia-Ouardigha",
  "MA-10": "Doukkala-Abda",
  "MA-11": "Marrakesh-Tensift-El Haouz",
  "MA-12": "Tadla-Azilal",
  "MD-AN": "Anenii Noi",
  "MD-BA": "Bălţi",
  "MD-BD": "Bender",
  "MD-BR": "Briceni",
  "MD-BS": "Basarabeasca",
  "MD-CA": "Cahul",
  "MD-CL": "Călărași",
  "MD-CM": "Cimișlia",
  "MD-CR": "Criuleni",
  "MD-CS": "Căușeni",
  "MD-CT": "Cantemir",
  "MD-CU": "Chișinău",
  "MD-DO": "Dondușeni",
  "MD-DR": "Drochia",
  "MD-DU": "Dubăsari",
  "MD-ED": "Edineț",
  "MD-FA": "Fălești",
  "MD-FL": "Florești",
  "MD-GA": "Gagauzia",
  "MD-GL": "Glodeni",
  "MD-HI": "Hîncești",
  "MD-IA": "Ialoveni",
  "MD-LE": "Leova",
  "MD-NI": "Nisporeni",
  "MD-OC": "Ocniţa",
  "MD-OR": "Orhei",
  "MD-RE": "Rezina",
  "MD-RI": "Rîșcani",
  "MD-SD": "Șoldănești",
  "MD-SI": "Sîngerei",
  "MD-SN": "Transnistria",
  "MD-SO": "Soroca",
  "MD-ST": "Strășeni",
  "MD-SV": "Ştefan Vodă",
  "MD-TA": "Taraclia",
  "MD-TE": "Telenești",
  "MD-UN": "Ungheni",
  "ME-01": "Andrijevica",
  "ME-02": "Bar",
  "ME-03": "Berane",
  "ME-04": "Bijelo Polje",
  "ME-05": "Budva",
  "ME-06": "Cetinje",
  "ME-07": "Danilovgrad",
  "ME-08": "Herceg Novi",
  "ME-09": "Kolašin",
  "ME-10": "Kotor",
  "ME-11": "Mojkovac",
  "ME-12": "Nikšić",
  "ME-13": "Plav",
  "ME-14": "Pljevlja",
  "ME-15": "Plužine",
  "ME-16": "Podgorica",
  "ME-17": "Rožaje",
  "ME-18": "Šavnik",
  "ME-19": "Tivat",
  "ME-20": "Ulcinj",
  "ME-21": "Žabljak",
  "ME-22": "Gusinje",
  "ME-23": "Petnjica",
  "ME-24": "Tuzi",
  "MG-A": "Toamasina",
  "MG-D": "Antsiranana",
  "MG-F": "Fianarantsoa",
  "MG-M": "Mahajanga",
  "MG-T": "Antananarivo",
  "MG-U": "Toliara",
  "MH-ALK": "Ailuk Atoll",
  "MH-ALL": "Ailinglaplap Atoll",
  "MH-ARN": "Arno",
  "MH-AUR": "Aur Atoll",
  "MH-EBO": "Ebon Atoll",
  "MH-ENI": "Enewetak Atoll",
  "MH-JAB": "Jabat Island",
  "MH-JAL": "Jaluit Atoll",
  "MH-KIL": "Kili Island",
  "MH-KWA": "Kwajalein",
  "MH-LAE": "Lae Atoll",
  "MH-LIB": "Lib Island",
  "MH-LIK": "Likiep Atoll",
  "MH-MAJ": "Majuro",
  "MH-MAL": "Maloelap Atoll",
  "MH-MEJ": "Mejit Island",
  "MH-MIL": "Mili Atoll",
  "MH-NMK": "Namdrik Atoll",
  "MH-NMU": "Namu Atoll",
  "MH-RON": "Rongelap Atoll",
  "MH-UJA": "Ujae Atoll",
  "MH-UTI": "Utirik Atoll",
  "MH-WTH": "Wotho Atoll",
  "MH-WTJ": "Wotje Atoll",
  "MK-101": "Veles",
  "MK-102": "Gradsko",
  "MK-103": "Demir Kapija",
  "MK-104": "Kavadarci",
  "MK-105": "Lozovo",
  "MK-201": "Berovo",
  "MK-202": "Vinica",
  "MK-203": "Delčevo",
  "MK-204": "Zrnovci",
  "MK-205": "Karbinci",
  "MK-206": "Kočani",
  "MK-207": "Makedonska Kamenica",
  "MK-208": "Pehčevo",
  "MK-209": "Probištip",
  "MK-210": "Češinovo-Obleševo",
  "MK-211": "Štip",
  "MK-301": "Vevčani",
  "MK-303": "Debar",
  "MK-304": "Debrca",
  "MK-307": "Kičevo",
  "MK-308": "Makedonski Brod",
  "MK-310": "Ohrid",
  "MK-311": "Plasnica",
  "MK-312": "Struga",
  "MK-401": "Bogdanci",
  "MK-402": "Bosilovo",
  "MK-403": "Valandovo",
  "MK-404": "Vasilevo",
  "MK-405": "Gevgelija",
  "MK-406": "Dojran",
  "MK-407": "Konče",
  "MK-408": "Novo Selo",
  "MK-409": "Radoviš",
  "MK-410": "Strumica",
  "MK-501": "Bitola",
  "MK-502": "Demir Hisar",
  "MK-503": "Dolneni",
  "MK-504": "Krivogaštani",
  "MK-505": "Kruševo",
  "MK-506": "Mogila",
  "MK-507": "Novaci",
  "MK-508": "Prilep",
  "MK-509": "Resen",
  "MK-601": "Bogovinje",
  "MK-602": "Brvenica",
  "MK-603": "Vrapčište",
  "MK-604": "Gostivar",
  "MK-605": "Želino",
  "MK-606": "Jegunovce",
  "MK-607": "Mavrovo i Rostuše",
  "MK-608": "Tearce",
  "MK-609": "Tetovo",
  "MK-701": "Kratovo",
  "MK-702": "Kriva Palanka",
  "MK-703": "Kumanovo",
  "MK-704": "Lipkovo",
  "MK-801": "Aerodrom †",
  "MK-802": "Aračinovo",
  "MK-803": "Butel †",
  "MK-804": "Gazi Baba †",
  "MK-805": "Gjorče Petrov †",
  "MK-806": "Zelenikovo",
  "MK-807": "Ilinden",
  "MK-808": "Karpoš †",
  "MK-809": "Kisela Voda †",
  "MK-810": "Petrovec",
  "MK-811": "Saraj †",
  "MK-812": "Sopište",
  "MK-813": "Studeničani",
  "MK-814": "Centar †",
  "MK-815": "Čair †",
  "ML-1": "Kayes",
  "ML-2": "Koulikoro",
  "ML-3": "Sikasso",
  "ML-4": "Ségou",
  "ML-5": "Mopti",
  "ML-6": "Tombouctou",
  "ML-7": "Gao",
  "ML-8": "Kidal",
  "ML-9": "Ménaka",
  "ML-BKO": "Bamako",
  "MM-01": "Sagaing",
  "MM-02": "Bago",
  "MM-03": "Magway",
  "MM-04": "Mandalay",
  "MM-05": "Tanintharyi",
  "MM-06": "Yangon",
  "MM-07": "Ayeyarwady",
  "MM-11": "Kachin",
  "MM-12": "Kayah",
  "MM-13": "Kayin",
  "MM-14": "Chin",
  "MM-15": "Mon",
  "MM-16": "Rakhine",
  "MM-17": "Shan",
  "MM-18": "Naypyidaw",
  "MR-01": "Hodh Ech Chargui",
  "MR-02": "Hodh El Gharbi",
  "MR-03": "Assaba",
  "MR-04": "Gorgol",
  "MR-05": "Brakna",
  "MR-06": "Trarza",
  "MR-07": "Adrar",
  "MR-08": "Dakhlet Nouadhibou",
  "MR-09": "Tagant",
  "MR-10": "Guidimaka",
  "MR-11": "Tiris Zemmour",
  "MR-12": "Inchiri",
  "MR-13": "Nouakchott Ouest",
  "MR-14": "Nouakchott Nord",
  "MR-15": "Nouakchott Sud",
  "MT-01": "Attard",
  "MT-02": "Balzan",
  "MT-03": "Birgu",
  "MT-04": "Birkirkara",
  "MT-05": "Birżebbuġa",
  "MT-06": "Cospicua",
  "MT-07": "Dingli",
  "MT-08": "Fgura",
  "MT-09": "Floriana",
  "MT-10": "Fontana",
  "MT-11": "Gudja",
  "MT-12": "Gżira",
  "MT-13": "Għajnsielem",
  "MT-14": "Għarb",
  "MT-15": "Għargħur",
  "MT-16": "Għasri",
  "MT-17": "Għaxaq",
  "MT-18": "Ħamrun",
  "MT-19": "Iklin",
  "MT-20": "Senglea",
  "MT-21": "Kalkara",
  "MT-22": "Kerċem",
  "MT-23": "Kirkop",
  "MT-24": "Lija",
  "MT-25": "Luqa",
  "MT-26": "Marsa",
  "MT-27": "Marsaskala",
  "MT-28": "Marsaxlokk",
  "MT-29": "Mdina",
  "MT-30": "Mellieħa",
  "MT-31": "Mġarr",
  "MT-32": "Mosta",
  "MT-33": "Mqabba",
  "MT-34": "Msida",
  "MT-35": "Imtarfa",
  "MT-36": "Munxar",
  "MT-37": "Nadur",
  "MT-38": "Naxxar",
  "MT-39": "Paola",
  "MT-40": "Pembroke",
  "MT-41": "Pietà",
  "MT-42": "Qala",
  "MT-43": "Qormi",
  "MT-44": "Qrendi",
  "MT-45": "Victoria",
  "MT-46": "Rabat",
  "MT-47": "Safi",
  "MT-48": "St. Julian’s",
  "MT-49": "San Ġwann",
  "MT-50": "Saint Lawrence",
  "MT-51": "St. Paul’s Bay",
  "MT-52": "Sannat",
  "MT-53": "Santa Luċija",
  "MT-54": "Santa Venera",
  "MT-55": "Siġġiewi",
  "MT-56": "Sliema",
  "MT-57": "Swieqi",
  "MT-58": "Ta’ Xbiex",
  "MT-59": "Tarxien",
  "MT-60": "Valletta",
  "MT-61": "Xagħra",
  "MT-62": "Xewkija",
  "MT-63": "Xgħajra",
  "MT-64": "Żabbar",
  "MT-65": "Żebbuġ Gozo",
  "MT-66": "Żebbuġ",
  "MT-67": "Żejtun",
  "MT-68": "Żurrieq",
  "MU-AG": "Agaléga",
  "MU-BL": "Rivière Noire",
  "MU-BR": "Beau-Bassin Rose-Hill",
  "MU-CC": "Cargados Carajos",
  "MU-CU": "Curepipe",
  "MU-FL": "Flacq",
  "MU-GP": "Grand Port",
  "MU-MO": "Moka",
  "MU-PA": "Pamplemousses",
  "MU-PL": "Port Louis District",
  "MU-PU": "Port Louis",
  "MU-PW": "Plaines Wilhems",
  "MU-QB": "Quatre Bornes",
  "MU-RO": "Rodrigues",
  "MU-RR": "Rivière du Rempart",
  "MU-SA": "Savanne",
  "MU-VP": "Vacoas-Phoenix",
  "MV-00": "Alif Dhaal",
  "MV-01": "Addu",
  "MV-02": "Alif Alif",
  "MV-03": "Lhaviyani",
  "MV-04": "Vaavu",
  "MV-05": "Laamu",
  "MV-07": "Haa Alif",
  "MV-08": "Thaa",
  "MV-12": "Meemu",
  "MV-13": "Raa",
  "MV-14": "Faafu",
  "MV-17": "Dhaalu",
  "MV-20": "Baa",
  "MV-23": "Haa Dhaalu",
  "MV-24": "Shaviyani",
  "MV-25": "Noonu",
  "MV-26": "Kaafu",
  "MV-27": "Gaafu Alif",
  "MV-28": "Gaafu Dhaalu",
  "MV-29": "Gnaviyani",
  "MV-CE": "Central Province",
  "MV-MLE": "Malé",
  "MV-NC": "North Central Province",
  "MV-NO": "North Province",
  "MV-SC": "South Central Province",
  "MV-SU": "South Province",
  "MV-UN": "Upper North Province",
  "MV-US": "Upper South Province",
  "MW-BA": "Balaka",
  "MW-BL": "Blantyre",
  "MW-C": "Central",
  "MW-CK": "Chikwawa",
  "MW-CR": "Chiradzulu",
  "MW-CT": "Chitipa",
  "MW-DE": "Dedza",
  "MW-DO": "Dowa",
  "MW-KR": "Karonga",
  "MW-KS": "Kasungu",
  "MW-LI": "Lilongwe",
  "MW-LK": "Likoma",
  "MW-MC": "Mchinji",
  "MW-MG": "Mangochi",
  "MW-MH": "Machinga",
  "MW-MU": "Mulanje",
  "MW-MW": "Mwanza",
  "MW-MZ": "Mzimba",
  "MW-N": "Northern",
  "MW-NB": "Nkhata Bay",
  "MW-NE": "Neno",
  "MW-NI": "Ntchisi",
  "MW-NK": "Nkhotakota",
  "MW-NS": "Nsanje",
  "MW-NU": "Ntcheu",
  "MW-PH": "Phalombe",
  "MW-RU": "Rumphi",
  "MW-S": "Southern",
  "MW-SA": "Salima",
  "MW-TH": "Thyolo",
  "MW-ZO": "Zomba",
  "MX-AGU": "Aguascalientes",
  "MX-BCN": "Baja California",
  "MX-BCS": "Baja California Sur",
  "MX-CAM": "Campeche",
  "MX-CHH": "Chihuahua",
  "MX-CHP": "Chiapas",
  "MX-CMX": "Ciudad de Mexico",
  "MX-COA": "Coahuila",
  "MX-COL": "Colima",
  "MX-DUR": "Durango",
  "MX-GRO": "Guerrero",
  "MX-GUA": "Guanajuato",
  "MX-HID": "Hidalgo",
  "MX-JAL": "Jalisco",
  "MX-MEX": "Mexico State",
  "MX-MIC": "Michoacán",
  "MX-MOR": "Morelos",
  "MX-NAY": "Nayarit",
  "MX-NLE": "Nuevo León",
  "MX-OAX": "Oaxaca",
  "MX-PUE": "Puebla",
  "MX-QUE": "Querétaro",
  "MX-ROO": "Quintana Roo",
  "MX-SIN": "Sinaloa",
  "MX-SLP": "San Luis Potosí",
  "MX-SON": "Sonora",
  "MX-TAB": "Tabasco",
  "MX-TAM": "Tamaulipas",
  "MX-TLA": "Tlaxcala",
  "MX-VER": "Veracruz",
  "MX-YUC": "Yucatán",
  "MX-ZAC": "Zacatecas",
  "MY-01": "Johor",
  "MY-02": "Kedah",
  "MY-03": "Kelantan",
  "MY-04": "Malacca",
  "MY-05": "Negeri Sembilan",
  "MY-06": "Pahang",
  "MY-07": "Penang",
  "MY-08": "Perak",
  "MY-09": "Perlis",
  "MY-10": "Selangor",
  "MY-11": "Terengganu",
  "MY-12": "Sabah",
  "MY-13": "Sarawak",
  "MY-14": "Kuala Lumpur",
  "MY-15": "Labuan",
  "MY-16": "Putrajaya",
  "MZ-A": "Niassa",
  "MZ-B": "Manica",
  "MZ-G": "Gaza",
  "MZ-I": "Inhambane",
  "MZ-L": "Maputo Province",
  "MZ-MPM": "Maputo",
  "MZ-N": "Nampula",
  "MZ-P": "Cabo Delgado",
  "MZ-Q": "Zambezia",
  "MZ-S": "Sofala",
  "MZ-T": "Tete",
  "NA-CA": "Zambezi",
  "NA-ER": "Erongo",
  "NA-HA": "Hardap",
  "NA-KA": "Karas",
  "NA-KE": "Kavango East",
  "NA-KH": "Khomas",
  "NA-KU": "Kunene",
  "NA-KW": "Kavango West",
  "NA-OD": "Otjozondjupa",
  "NA-OH": "Omaheke",
  "NA-ON": "Oshana",
  "NA-OS": "Omusati",
  "NA-OT": "Oshikoto",
  "NA-OW": "Ohangwena",
  "NE-1": "Agadez",
  "NE-2": "Diffa",
  "NE-3": "Dosso",
  "NE-4": "Maradi",
  "NE-5": "Tahoua",
  "NE-6": "Tillabéri",
  "NE-7": "Zinder",
  "NE-8": "Niamey",
  "NG-AB": "Abia",
  "NG-AD": "Adamawa",
  "NG-AK": "Akwa Ibom",
  "NG-AN": "Anambra",
  "NG-BA": "Bauchi",
  "NG-BE": "Benue",
  "NG-BO": "Borno",
  "NG-BY": "Bayelsa",
  "NG-CR": "Cross River",
  "NG-DE": "Delta",
  "NG-EB": "Ebonyi",
  "NG-ED": "Edo",
  "NG-EK": "Ekiti",
  "NG-EN": "Enugu",
  "NG-FC": "Federal Capital Territory",
  "NG-GO": "Gombe",
  "NG-IM": "Imo",
  "NG-JI": "Jigawa",
  "NG-KD": "Kaduna",
  "NG-KE": "Kebbi",
  "NG-KN": "Kano",
  "NG-KO": "Kogi",
  "NG-KW": "Kwara",
  "NG-LA": "Lagos",
  "NG-NA": "Nasarawa",
  "NG-NI": "Niger",
  "NG-OG": "Ogun",
  "NG-ON": "Ondo",
  "NG-OS": "Osun",
  "NG-OY": "Oyo",
  "NG-PL": "Plateau",
  "NG-RI": "Rivers",
  "NG-SO": "Sokoto",
  "NG-TA": "Taraba",
  "NG-YO": "Yobe",
  "NG-ZA": "Zamfara",
  "NI-AN": "Atlántico Norte",
  "NI-AS": "Atlántico Sur",
  "NI-BO": "Boaco",
  "NI-CA": "Carazo",
  "NI-CI": "Chinandega",
  "NI-CO": "Chontales",
  "NI-ES": "Estelí",
  "NI-GR": "Granada",
  "NI-JI": "Jinotega",
  "NI-LE": "León",
  "NI-MD": "Madriz",
  "NI-MN": "Managua",
  "NI-MS": "Masaya",
  "NI-MT": "Matagalpa",
  "NI-NS": "Nueva Segovia",
  "NI-RI": "Rivas",
  "NI-SJ": "Río San Juan",
  "NL-DR": "Drenthe",
  "NL-FL": "Flevoland",
  "NL-FR": "Friesland",
  "NL-GE": "Gelderland",
  "NL-GR": "Groningen",
  "NL-LI": "Limburg",
  "NL-NB": "North Brabant",
  "NL-NH": "North Holland",
  "NL-OV": "Overijssel",
  "NL-UT": "Utrecht",
  "NL-ZE": "Zeeland",
  "NL-ZH": "South Holland",
  "NO-03": "Oslo",
  "NO-11": "Rogaland",
  "NO-15": "Møre og Romsdal",
  "NO-18": "Nordland",
  "NO-21": "Svalbard",
  "NO-30": "Viken",
  "NO-34": "Innlandet",
  "NO-38": "Vestfold og Telemark",
  "NO-42": "Agder",
  "NO-46": "Vestland",
  "NO-50": "Trøndelag",
  "NO-54": "Tromssan ja Finmarkun",
  "NP-1": "Central",
  "NP-2": "Madhya Pashchimanchal",
  "NP-3": "Western",
  "NP-4": "Purwanchal",
  "NP-5": "Sudur Pashchimanchal",
  "NR-01": "Aiwo",
  "NR-02": "Anabar",
  "NR-03": "Anetan",
  "NR-04": "Anibare",
  "NR-05": "Baiti",
  "NR-06": "Boe",
  "NR-07": "Buada",
  "NR-08": "Denigomodu",
  "NR-09": "Ewa",
  "NR-10": "Ijuw",
  "NR-11": "Meneng",
  "NR-12": "Nibok",
  "NR-13": "Uaboe",
  "NR-14": "Yaren",
  "NZ-AUK": "Auckland",
  "NZ-BOP": "Bay of Plenty",
  "NZ-CAN": "Canterbury",
  "NZ-GIS": "Gisborne",
  "NZ-HKB": "Hawke’s Bay",
  "NZ-MBH": "Marl",
  "NZ-MWT": "Manawatu-Wanganui",
  "NZ-NSN": "Nelson",
  "NZ-NTL": "Northland",
  "NZ-OTA": "Otago",
  "NZ-STL": "Southland",
  "NZ-TAS": "Tasman",
  "NZ-TKI": "Taranaki",
  "NZ-WGN": "Wellington",
  "NZ-WKO": "Waikato",
  "NZ-WTC": "West Coast",
  "OM-BJ": "Janub al Batinah",
  "OM-BS": "Shamal al Batinah",
  "OM-BU": "Al Buraimi",
  "OM-DA": "Ad Dakhiliyah",
  "OM-MA": "Muscat",
  "OM-MU": "Musandam",
  "OM-SJ": "Janub ash Sharqiyah",
  "OM-SS": "Shamal ash Sharqiyah",
  "OM-WU": "Al Wusta",
  "OM-ZA": "Ad Dhahirah",
  "OM-ZU": "Dhofar",
  "PA-1": "Bocas del Toro",
  "PA-10": "West Panamá",
  "PA-2": "Coclé",
  "PA-3": "Colón",
  "PA-4": "Chiriquí",
  "PA-5": "Darién",
  "PA-6": "Herrera",
  "PA-7": "Los Santos",
  "PA-8": "Panamá",
  "PA-9": "Veraguas",
  "PA-EM": "Emberá",
  "PA-KY": "Guna Yala",
  "PA-NB": "Ngöbe-Buglé",
  "PE-AMA": "Amazonas",
  "PE-ANC": "Ancash",
  "PE-APU": "Apurímac",
  "PE-ARE": "Arequipa",
  "PE-AYA": "Ayacucho",
  "PE-CAJ": "Cajamarca",
  "PE-CAL": "El Callao",
  "PE-CUS": "Cusco",
  "PE-HUC": "Huánuco",
  "PE-HUV": "Huancavelica",
  "PE-ICA": "Ica",
  "PE-JUN": "Junín",
  "PE-LAL": "La Libertad",
  "PE-LAM": "Lambayeque",
  "PE-LIM": "Lima Region",
  "PE-LMA": "Lima",
  "PE-LOR": "Loreto",
  "PE-MDD": "Madre de Dios",
  "PE-MOQ": "Moquegua",
  "PE-PAS": "Pasco",
  "PE-PIU": "Piura",
  "PE-PUN": "Puno",
  "PE-SAM": "San Martín",
  "PE-TAC": "Tacna",
  "PE-TUM": "Tumbes",
  "PE-UCA": "Ucayali",
  "PG-CPK": "Chimbu",
  "PG-CPM": "Central",
  "PG-EBR": "East New Britain",
  "PG-EHG": "Eastern Highlands",
  "PG-EPW": "Enga",
  "PG-ESW": "East Sepik",
  "PG-GPK": "Gulf",
  "PG-HLA": "Hela",
  "PG-JWK": "Jiwaka",
  "PG-MBA": "Milne Bay",
  "PG-MPL": "Morobe",
  "PG-MPM": "Madang",
  "PG-MRL": "Manus",
  "PG-NCD": "Port Moresby",
  "PG-NIK": "New Ireland",
  "PG-NPP": "Oro",
  "PG-NSB": "Bougainville",
  "PG-SAN": "Sandaun",
  "PG-SHM": "Southern Highlands",
  "PG-WBK": "West New Britain",
  "PG-WHM": "Western Highlands",
  "PG-WPD": "Western",
  "PH-00": "Metro Manila",
  "PH-01": "Ilocos",
  "PH-02": "Cagayan Valley",
  "PH-03": "Central Luzon",
  "PH-05": "Bicol",
  "PH-06": "Western Visayas",
  "PH-07": "Central Visayas",
  "PH-08": "Eastern Visayas",
  "PH-09": "Zamboanga Peninsula",
  "PH-10": "Northern Mindanao",
  "PH-11": "Davao",
  "PH-12": "Soccsksargen",
  "PH-13": "Caraga",
  "PH-14": "Muslim Mindanao",
  "PH-15": "Cordillera Administrative",
  "PH-40": "Calabarzon",
  "PH-41": "Mimaropa",
  "PK-BA": "Balochistan",
  "PK-GB": "Gilgit-Baltistan",
  "PK-IS": "Islamabad",
  "PK-JK": "Azad Kashmir",
  "PK-KP": "Khyber Pakhtunkhwa",
  "PK-PB": "Punjab",
  "PK-SD": "Sindh",
  "PK-TA": "Federally Administered Tribal Areas",
  "PS-BTH": "Bethlehem",
  "PS-DEB": "Deir al-Balah",
  "PS-GZA": "Gaza",
  "PS-HBN": "Hebron",
  "PS-JEM": "Jerusalem",
  "PS-JEN": "Jenin",
  "PS-JRH": "Jericho",
  "PS-KYS": "Khan Yunis",
  "PS-NBS": "Nablus",
  "PS-NGZ": "North Gaza",
  "PS-QQA": "Qalqilya",
  "PS-RBH": "Ramallah and al-Bireh",
  "PS-RFH": "Rafah",
  "PS-SLT": "Salfit",
  "PS-TBS": "Tubas",
  "PS-TKM": "Tulkarm",
  "PT-01": "Aveiro",
  "PT-02": "Beja",
  "PT-03": "Braga",
  "PT-04": "Bragança",
  "PT-05": "Castelo Branco",
  "PT-06": "Coimbra",
  "PT-07": "Évora",
  "PT-08": "Faro",
  "PT-09": "Guarda",
  "PT-10": "Leiria",
  "PT-11": "Lisbon",
  "PT-12": "Portalegre",
  "PT-13": "Porto",
  "PT-14": "Santarém",
  "PT-15": "Setúbal",
  "PT-16": "Viana do Castelo",
  "PT-17": "Vila Real",
  "PT-18": "Viseu",
  "PT-20": "Azores",
  "PT-30": "Madeira",
  "PW-002": "Aimeliik",
  "PW-004": "Airai",
  "PW-010": "Angaur",
  "PW-050": "Hatohobei",
  "PW-100": "Kayangel",
  "PW-150": "Koror",
  "PW-212": "Melekeok",
  "PW-214": "Ngaraard",
  "PW-218": "Ngarchelong",
  "PW-222": "Ngardmau",
  "PW-224": "Ngatpang",
  "PW-226": "Ngchesar",
  "PW-227": "Ngeremlengui",
  "PW-228": "Ngiwal",
  "PW-350": "Peleliu",
  "PW-370": "Sonsorol",
  "PY-1": "Concepción",
  "PY-10": "Alto Paraná",
  "PY-11": "Central",
  "PY-12": "Ñeembucú",
  "PY-13": "Amambay",
  "PY-14": "Canindeyú",
  "PY-15": "Presidente Hayes",
  "PY-16": "Alto Paraguay",
  "PY-2": "San Pedro",
  "PY-3": "Cordillera",
  "PY-4": "Guairá",
  "PY-5": "Caaguazú",
  "PY-6": "Caazapá",
  "PY-7": "Itapúa",
  "PY-8": "Misiones",
  "PY-9": "Paraguarí",
  "PY-ASU": "Asunción",
  "QA-DA": "Doha",
  "QA-KH": "Al Khor",
  "QA-MS": "Madinat ash Shamal",
  "QA-RA": "Al Rayyan",
  "QA-SH": "Ash Shīḩānīyah",
  "QA-US": "Umm Salal",
  "QA-WA": "Al Wakrah",
  "QA-ZA": "Al Daayen",
  "RO-AB": "Alba",
  "RO-AG": "Argeș",
  "RO-AR": "Arad",
  "RO-B": "Bucharest",
  "RO-BC": "Bacău",
  "RO-BH": "Bihor",
  "RO-BN": "Bistriţa-Năsăud",
  "RO-BR": "Brăila",
  "RO-BT": "Botoşani",
  "RO-BV": "Braşov",
  "RO-BZ": "Buzău",
  "RO-CJ": "Cluj",
  "RO-CL": "Călărași",
  "RO-CS": "Caraș-Severin",
  "RO-CT": "Constanța",
  "RO-CV": "Covasna",
  "RO-DB": "Dâmbovița",
  "RO-DJ": "Dolj",
  "RO-GJ": "Gorj",
  "RO-GL": "Galați",
  "RO-GR": "Giurgiu",
  "RO-HD": "Hunedoara",
  "RO-HR": "Harghita",
  "RO-IF": "Ilfov",
  "RO-IL": "Ialomița",
  "RO-IS": "Iași",
  "RO-MH": "Mehedinți",
  "RO-MM": "Maramureş",
  "RO-MS": "Mureş",
  "RO-NT": "Neamţ",
  "RO-OT": "Olt",
  "RO-PH": "Prahova",
  "RO-SB": "Sibiu",
  "RO-SJ": "Sălaj",
  "RO-SM": "Satu Mare",
  "RO-SV": "Suceava",
  "RO-TL": "Tulcea",
  "RO-TM": "Timiș",
  "RO-TR": "Teleorman",
  "RO-VL": "Vâlcea",
  "RO-VN": "Vrancea",
  "RO-VS": "Vaslui",
  "RS-00": "Beograd",
  "RS-01": "North Bačka",
  "RS-02": "Central Banat",
  "RS-03": "North Banat",
  "RS-04": "South Banat",
  "RS-05": "West Bačka",
  "RS-06": "South Bačka",
  "RS-07": "Srem",
  "RS-08": "Mačva",
  "RS-09": "Kolubara",
  "RS-10": "Podunavlje",
  "RS-11": "Braničevo",
  "RS-12": "Šumadija",
  "RS-13": "Pomoravlje",
  "RS-14": "Bor",
  "RS-15": "Zaječar",
  "RS-16": "Zlatibor",
  "RS-17": "Moravica",
  "RS-18": "Raška",
  "RS-19": "Rasina",
  "RS-20": "Nišava",
  "RS-21": "Toplica",
  "RS-22": "Pirot",
  "RS-23": "Jablanica",
  "RS-24": "Pčinja",
  "RS-25": "Kosovo",
  "RS-26": "Peć",
  "RS-27": "Prizren",
  "RS-28": "Kosovska Mitrovica",
  "RS-29": "Kosovo-Pomoravlje",
  "SA-01": "Riyadh",
  "SA-02": "Makkah",
  "SA-03": "Al Madinah",
  "SA-04": "Eastern",
  "SA-05": "Al-Qassim",
  "SA-06": "Ha’il",
  "SA-07": "Tabuk",
  "SA-08": "Northern Borders",
  "SA-09": "Jizan",
  "SA-10": "Najran",
  "SA-11": "Al Bahah",
  "SA-12": "Al Jawf",
  "SB-CE": "Central",
  "SB-CH": "Choiseul",
  "SB-CT": "Honiara",
  "SB-GU": "Guadalcanal",
  "SB-IS": "Isabel",
  "SB-MK": "Makira-Ulawa",
  "SB-ML": "Malaita",
  "SB-RB": "Rennell and Bellona",
  "SB-TE": "Temotu",
  "SB-WE": "Western",
  "SC-01": "Anse aux Pins",
  "SC-02": "Anse Boileau",
  "SC-03": "Anse Etoile",
  "SC-04": "Au Cap",
  "SC-05": "Anse Royale",
  "SC-06": "Baie Lazare",
  "SC-07": "Baie Sainte Anne",
  "SC-08": "Beau Vallon",
  "SC-09": "Bel Air",
  "SC-10": "Bel Ombre",
  "SC-11": "Cascade",
  "SC-12": "Glacis",
  "SC-13": "Grand’Anse Mahé",
  "SC-14": "Grand’Anse Praslin",
  "SC-15": "La Digue",
  "SC-16": "La Rivière Anglaise",
  "SC-17": "Mont Buxton",
  "SC-18": "Mont Fleuri",
  "SC-19": "Plaisance",
  "SC-20": "Pointe La Rue",
  "SC-21": "Port Glaud",
  "SC-22": "Saint Louis",
  "SC-23": "Takamaka",
  "SC-24": "Les Mamelles",
  "SC-25": "Roche Caiman",
  "SC-26": "Ile Perseverance I",
  "SC-27": "Ile Perseverance II",
  "SD-DC": "Central Darfur",
  "SD-DE": "East Darfur",
  "SD-DN": "North Darfur",
  "SD-DS": "South Darfur",
  "SD-DW": "West Darfur",
  "SD-GD": "Al Qadarif",
  "SD-GK": "West Kurdufan",
  "SD-GZ": "Al Jazirah",
  "SD-KA": "Kassala",
  "SD-KH": "Khartoum",
  "SD-KN": "North Kurdufan",
  "SD-KS": "South Kurdufan",
  "SD-NB": "Blue Nile",
  "SD-NO": "Northern",
  "SD-NR": "River Nile",
  "SD-NW": "White Nile",
  "SD-RS": "Red Sea",
  "SD-SI": "Sennar",
  "SE-AB": "Stockholm",
  "SE-AC": "Västerbotten",
  "SE-BD": "Norrbotten",
  "SE-C": "Uppsala",
  "SE-D": "Södermanland",
  "SE-E": "Östergötland",
  "SE-F": "Jönköping",
  "SE-G": "Kronoberg",
  "SE-H": "Kalmar",
  "SE-I": "Gotland",
  "SE-K": "Blekinge",
  "SE-M": "Skåne",
  "SE-N": "Halland",
  "SE-O": "Västra Götaland",
  "SE-S": "Värmland",
  "SE-T": "Örebro",
  "SE-U": "Västmanland",
  "SE-W": "Dalarna",
  "SE-X": "Gävleborg",
  "SE-Y": "Västernorrland",
  "SE-Z": "Jämtland",
  "SI-001": "Ajdovščina",
  "SI-002": "Beltinci",
  "SI-003": "Bled",
  "SI-004": "Bohinj",
  "SI-005": "Borovnica",
  "SI-006": "Bovec",
  "SI-007": "Brda",
  "SI-008": "Brezovica",
  "SI-009": "Brežice",
  "SI-010": "Tišina",
  "SI-011": "Celje",
  "SI-012": "Cerklje na Gorenjskem",
  "SI-013": "Cerknica",
  "SI-014": "Cerkno",
  "SI-015": "Črenšovci",
  "SI-016": "Črna na Koroškem",
  "SI-017": "Črnomelj",
  "SI-018": "Destrnik",
  "SI-019": "Divača",
  "SI-020": "Dobrepolje",
  "SI-021": "Dobrova–Polhov Gradec",
  "SI-022": "Dol pri Ljubljani",
  "SI-023": "Domžale",
  "SI-024": "Dornava",
  "SI-025": "Dravograd",
  "SI-026": "Duplek",
  "SI-027": "Gorenja Vas–Poljane",
  "SI-028": "Gorišnica",
  "SI-029": "Gornja Radgona",
  "SI-030": "Gornji Grad",
  "SI-031": "Gornji Petrovci",
  "SI-032": "Grosuplje",
  "SI-033": "Šalovci",
  "SI-034": "Hrastnik",
  "SI-035": "Hrpelje–Kozina",
  "SI-036": "Idrija",
  "SI-037": "Ig",
  "SI-038": "Ilirska Bistrica",
  "SI-039": "Ivančna Gorica",
  "SI-040": "Izola",
  "SI-041": "Jesenice",
  "SI-042": "Juršinci",
  "SI-043": "Kamnik",
  "SI-044": "Kanal",
  "SI-045": "Kidričevo",
  "SI-046": "Kobarid",
  "SI-047": "Kobilje",
  "SI-048": "Kočevje",
  "SI-049": "Komen",
  "SI-050": "Koper",
  "SI-051": "Kozje",
  "SI-052": "Kranj",
  "SI-053": "Kranjska Gora",
  "SI-054": "Krško",
  "SI-055": "Kungota",
  "SI-056": "Kuzma",
  "SI-057": "Laško",
  "SI-058": "Lenart",
  "SI-059": "Lendava",
  "SI-060": "Litija",
  "SI-061": "Ljubljana",
  "SI-062": "Ljubno",
  "SI-063": "Ljutomer",
  "SI-064": "Logatec",
  "SI-065": "Loška Dolina",
  "SI-066": "Loški Potok",
  "SI-067": "Luče",
  "SI-068": "Lukovica",
  "SI-069": "Majšperk",
  "SI-070": "Maribor",
  "SI-071": "Medvode",
  "SI-072": "Mengeš",
  "SI-073": "Metlika",
  "SI-074": "Mežica",
  "SI-075": "Miren–Kostanjevica",
  "SI-076": "Mislinja",
  "SI-077": "Moravče",
  "SI-078": "Moravske Toplice",
  "SI-079": "Mozirje",
  "SI-080": "Murska Sobota",
  "SI-081": "Muta",
  "SI-082": "Naklo",
  "SI-083": "Nazarje",
  "SI-084": "Nova Gorica",
  "SI-085": "Novo Mesto",
  "SI-086": "Odranci",
  "SI-087": "Ormož",
  "SI-088": "Osilnica",
  "SI-089": "Pesnica",
  "SI-090": "Piran",
  "SI-091": "Pivka",
  "SI-092": "Podčetrtek",
  "SI-093": "Podvelka",
  "SI-094": "Postojna",
  "SI-095": "Preddvor",
  "SI-096": "Ptuj",
  "SI-097": "Puconci",
  "SI-098": "Rače–Fram",
  "SI-099": "Radeče",
  "SI-100": "Radenci",
  "SI-101": "Radlje ob Dravi",
  "SI-102": "Radovljica",
  "SI-103": "Ravne na Koroškem",
  "SI-104": "Ribnica",
  "SI-105": "Rogašovci",
  "SI-106": "Rogaška Slatina",
  "SI-107": "Rogatec",
  "SI-108": "Ruše",
  "SI-109": "Semič",
  "SI-110": "Sevnica",
  "SI-111": "Sežana",
  "SI-112": "Slovenj Gradec",
  "SK-BC": "Banská Bystrica",
  "SK-BL": "Bratislava",
  "SK-KI": "Košice",
  "SK-NI": "Nitra",
  "SK-PV": "Prešov",
  "SK-TA": "Trnava",
  "SK-TC": "Trenčín",
  "SK-ZI": "Žilina",
  "SL-E": "Eastern",
  "SL-N": "Northern",
  "SL-NW": "North Western",
  "SL-S": "Southern",
  "SL-W": "Western Area",
  "SM-01": "Acquaviva",
  "SM-02": "Chiesanuova",
  "SM-03": "Domagnano",
  "SM-04": "Faetano",
  "SM-05": "Fiorentino",
  "SM-06": "Borgo Maggiore",
  "SM-07": "San Marino",
  "SM-08": "Montegiardino",
  "SM-09": "Serravalle",
  "SN-DB": "Diourbel",
  "SN-DK": "Dakar",
  "SN-FK": "Fatick",
  "SN-KA": "Kaffrine",
  "SN-KD": "Kolda",
  "SN-KE": "Kédougou",
  "SN-KL": "Kaolack",
  "SN-LG": "Louga",
  "SN-MT": "Matam",
  "SN-SE": "Sédhiou",
  "SN-SL": "Saint-Louis",
  "SN-TC": "Tambacounda",
  "SN-TH": "Thiès",
  "SN-ZG": "Ziguinchor",
  "SO-AW": "Awdal",
  "SO-BK": "Bakool",
  "SO-BN": "Banaadir",
  "SO-BR": "Bari",
  "SO-BY": "Bay, Somalia",
  "SO-GA": "Galguduud",
  "SO-GE": "Gedo",
  "SO-HI": "Hiran",
  "SO-JD": "Middle Juba",
  "SO-JH": "Lower Juba",
  "SO-MU": "Mudug",
  "SO-NU": "Nugal",
  "SO-SA": "Sanaag",
  "SO-SD": "Middle Shebelle",
  "SO-SH": "Lower Shebelle",
  "SO-SO": "Sool",
  "SO-TO": "Togdheer",
  "SO-WO": "Woqooyi Galbeed",
  "SR-BR": "Brokopondo",
  "SR-CM": "Commewijne",
  "SR-CR": "Coronie",
  "SR-MA": "Marowijne",
  "SR-NI": "Nickerie",
  "SR-PM": "Paramaribo",
  "SR-PR": "Para",
  "SR-SA": "Saramacca",
  "SR-SI": "Sipaliwini",
  "SR-WA": "Wanica",
  "SS-BN": "Northern Bahr el Ghazal",
  "SS-BW": "Western Bahr el Ghazal",
  "SS-EC": "Central Equatoria",
  "SS-EE": "Eastern Equatoria",
  "SS-JG": "Jonglei",
  "SS-LK": "Lakes",
  "SS-NU": "Upper Nile",
  "SS-UY": "Unity",
  "SS-WR": "Warrap",
  "ST-01": "Água Grande",
  "ST-02": "Cantagalo",
  "ST-03": "Caué",
  "ST-04": "Lembá",
  "ST-05": "Lobata",
  "ST-06": "Mé-Zóchi",
  "ST-P": "Príncipe",
  "SV-AH": "Ahuachapán",
  "SV-CA": "Cabañas",
  "SV-CH": "Chalatenango",
  "SV-CU": "Cuscatlán",
  "SV-LI": "La Libertad",
  "SV-MO": "Morazán",
  "SV-PA": "La Paz",
  "SV-SA": "Santa Ana",
  "SV-SM": "San Miguel",
  "SV-SO": "Sonsonate",
  "SV-SS": "San Salvador",
  "SV-SV": "San Vicente",
  "SV-UN": "La Unión",
  "SV-US": "Usulután",
  "SY-DI": "Damascus",
  "SY-DR": "Daraa",
  "SY-DY": "Deir ez-Zor",
  "SY-HA": "Al-Hasakah",
  "SY-HI": "Homs",
  "SY-HM": "Hama",
  "SY-ID": "Idlib",
  "SY-LA": "Latakia",
  "SY-QU": "Quneitra",
  "SY-RA": "Ar-Raqqah",
  "SY-RD": "Rif Dimashq",
  "SY-SU": "As-Suwayda",
  "SY-TA": "Tartus",
  "SZ-HH": "Hhohho",
  "SZ-LU": "Lubombo",
  "SZ-MA": "Manzini",
  "SZ-SH": "Shiselweni",
  "TD-BA": "Batha",
  "TD-BG": "Bahr el Gazel",
  "TD-BO": "Borkou",
  "TD-CB": "Chari-Baguirmi",
  "TD-EE": "Ennedi-Est",
  "TD-EO": "Ennedi-Ouest",
  "TD-GR": "Guéra",
  "TD-HL": "Hadjer-Lamis",
  "TD-KA": "Kanem",
  "TD-LC": "Lac",
  "TD-LO": "Logone Occidental",
  "TD-LR": "Logone Oriental",
  "TD-MA": "Mandoul",
  "TD-MC": "Moyen-Chari",
  "TD-ME": "Mayo-Kebbi Est",
  "TD-MO": "Mayo-Kebbi Ouest",
  "TD-ND": "N’Djamena",
  "TD-OD": "Ouaddaï",
  "TD-SA": "Salamat",
  "TD-SI": "Sila",
  "TD-TA": "Tandjilé",
  "TD-TI": "Tibesti",
  "TD-WF": "Wadi Fira",
  "TG-C": "Centrale",
  "TG-K": "Kara",
  "TG-M": "Maritime",
  "TG-P": "Plateaux",
  "TG-S": "Savanes",
  "TH-10": "Bangkok",
  "TH-11": "Samut Prakan",
  "TH-12": "Nonthaburi",
  "TH-13": "Pathum Thani",
  "TH-14": "Phra Nakhon Si Ayutthaya",
  "TH-15": "Ang Thong",
  "TH-16": "Lopburi",
  "TH-17": "Sing Buri",
  "TH-18": "Chai Nat",
  "TH-19": "Saraburi",
  "TH-20": "Chon Buri",
  "TH-21": "Rayong",
  "TH-22": "Chanthaburi",
  "TH-23": "Trat",
  "TH-24": "Chachoengsao",
  "TH-25": "Prachin Buri",
  "TH-26": "Nakhon Nayok",
  "TH-27": "Sa Kaeo",
  "TH-30": "Nakhon Ratchasima",
  "TH-31": "Buri Ram",
  "TH-32": "Surin",
  "TH-33": "Si Sa Ket",
  "TH-34": "Ubon Ratchathani",
  "TH-35": "Yasothon",
  "TH-36": "Chaiyaphum",
  "TH-37": "Amnat Charoen",
  "TH-38": "Bueng Kan",
  "TH-39": "Nong Bua Lam Phu",
  "TH-40": "Khon Kaen",
  "TH-41": "Udon Thani",
  "TH-42": "Loei",
  "TH-43": "Nong Khai",
  "TH-44": "Maha Sarakham",
  "TH-45": "Roi Et",
  "TH-46": "Kalasin",
  "TH-47": "Sakon Nakhon",
  "TH-48": "Nakhon Phanom",
  "TH-49": "Mukdahan",
  "TH-50": "Chiang Mai",
  "TH-51": "Lamphun",
  "TH-52": "Lampang",
  "TH-53": "Uttaradit",
  "TH-54": "Phrae",
  "TH-55": "Nan",
  "TH-56": "Phayao",
  "TH-57": "Chiang Rai",
  "TH-58": "Mae Hong Son",
  "TH-60": "Nakhon Sawan",
  "TH-61": "Uthai Thani",
  "TH-62": "Kamphaeng Phet",
  "TH-63": "Tak",
  "TH-64": "Sukhothai",
  "TH-65": "Phitsanulok",
  "TH-66": "Phichit",
  "TH-67": "Phetchabun",
  "TH-70": "Ratchaburi",
  "TH-71": "Kanchanaburi",
  "TH-72": "Suphanburi",
  "TH-73": "Nakhon Pathom",
  "TH-74": "Samut Sakhon",
  "TH-75": "Samut Songkhram",
  "TH-76": "Phetchaburi",
  "TH-77": "Prachuap Khiri Khan",
  "TH-80": "Nakhon Si Thammarat",
  "TH-81": "Krabi",
  "TH-82": "Phang Nga",
  "TH-83": "Phuket",
  "TH-84": "Surat Thani",
  "TH-85": "Ranong",
  "TH-86": "Chumphon",
  "TH-90": "Songkhla",
  "TH-91": "Satun",
  "TH-92": "Trang",
  "TH-93": "Phatthalung",
  "TH-94": "Pattani",
  "TH-95": "Yala",
  "TH-96": "Narathiwat",
  "TH-S": "Pattaya",
  "TJ-DU": "Dushanbe",
  "TJ-GB": "Gorno-Badakhshan",
  "TJ-KT": "Khatlon",
  "TJ-RA": "Nohiyahoi Tobei Jumhurí",
  "TJ-SU": "Sughd",
  "TL-AL": "Aileu",
  "TL-AN": "Ainaro",
  "TL-BA": "Baucau",
  "TL-BO": "Bobonaro",
  "TL-CO": "Cova Lima",
  "TL-DI": "Dili",
  "TL-ER": "Ermera",
  "TL-LA": "Lautém",
  "TL-LI": "Liquiçá",
  "TL-MF": "Manufahi",
  "TL-MT": "Manatuto",
  "TL-OE": "Oecusse",
  "TL-VI": "Viqueque",
  "TM-A": "Ahal",
  "TM-B": "Balkan",
  "TM-D": "Daşoguz",
  "TM-L": "Lebap",
  "TM-M": "Mary",
  "TM-S": "Aşgabat",
  "TN-11": "Tunis",
  "TN-12": "Ariana",
  "TN-13": "Ben Arous",
  "TN-14": "Manouba",
  "TN-21": "Nabeul",
  "TN-22": "Zaghouan",
  "TN-23": "Bizerte",
  "TN-31": "Béja",
  "TN-32": "Jendouba",
  "TN-33": "Kef",
  "TN-34": "Siliana",
  "TN-41": "Kairouan",
  "TN-42": "Kasserine",
  "TN-43": "Sidi Bouzid",
  "TN-51": "Sousse",
  "TN-52": "Monastir",
  "TN-53": "Mahdia",
  "TN-61": "Sfax",
  "TN-71": "Gafsa",
  "TN-72": "Tozeur",
  "TN-73": "Kebili",
  "TN-81": "Gabès",
  "TN-82": "Medenine",
  "TN-83": "Tataouine",
  "TO-01": "ʻEua",
  "TO-02": "Haʻapai",
  "TO-03": "Niuas",
  "TO-04": "Tongatapu",
  "TO-05": "Vavaʻu",
  "TR-01": "Adana",
  "TR-02": "Adıyaman",
  "TR-03": "Afyonkarahisar",
  "TR-04": "Ağrı",
  "TR-05": "Amasya",
  "TR-06": "Ankara",
  "TR-07": "Antalya",
  "TR-08": "Artvin",
  "TR-09": "Aydın",
  "TR-10": "Balıkesir",
  "TR-11": "Bilecik",
  "TR-12": "Bingöl",
  "TR-13": "Bitlis",
  "TR-14": "Bolu",
  "TR-15": "Burdur",
  "TR-16": "Bursa",
  "TR-17": "Çanakkale",
  "TR-18": "Çankırı",
  "TR-19": "Çorum",
  "TR-20": "Denizli",
  "TR-21": "Diyarbakır",
  "TR-22": "Edirne",
  "TR-23": "Elazığ",
  "TR-24": "Erzincan",
  "TR-25": "Erzurum",
  "TR-26": "Eskişehir",
  "TR-27": "Gaziantep",
  "TR-28": "Giresun",
  "TR-29": "Gümüşhane",
  "TR-30": "Hakkâri",
  "TR-31": "Hatay",
  "TR-32": "Isparta",
  "TR-33": "Mersin",
  "TR-34": "Istanbul",
  "TR-35": "Izmir",
  "TR-36": "Kars",
  "TR-37": "Kastamonu",
  "TR-38": "Kayseri",
  "TR-39": "Kırklareli",
  "TR-40": "Kırşehir",
  "TR-41": "Kocaeli",
  "TR-42": "Konya",
  "TR-43": "Kütahya",
  "TR-44": "Malatya",
  "TR-45": "Manisa",
  "TR-46": "Kahramanmaraş",
  "TR-47": "Mardin",
  "TR-48": "Muğla",
  "TR-49": "Muş",
  "TR-50": "Nevşehir",
  "TR-51": "Niğde",
  "TR-52": "Ordu",
  "TR-53": "Rize",
  "TR-54": "Sakarya",
  "TR-55": "Samsun",
  "TR-56": "Siirt",
  "TR-57": "Sinop",
  "TR-58": "Sivas",
  "TR-59": "Tekirdağ",
  "TR-60": "Tokat",
  "TR-61": "Trabzon",
  "TR-62": "Tunceli",
  "TR-63": "Şanlıurfa",
  "TR-64": "Uşak",
  "TR-65": "Van",
  "TR-66": "Yozgat",
  "TR-67": "Zonguldak",
  "TR-68": "Aksaray",
  "TR-69": "Bayburt",
  "TR-70": "Karaman",
  "TR-71": "Kırıkkale",
  "TR-72": "Batman",
  "TR-73": "Şırnak",
  "TR-74": "Bartın",
  "TR-75": "Ardahan",
  "TR-76": "Iğdır",
  "TR-77": "Yalova",
  "TR-78": "Karabük",
  "TR-79": "Kilis",
  "TR-80": "Osmaniye",
  "TR-81": "Düzce",
  "TT-ARI": "Arima",
  "TT-CHA": "Chaguanas",
  "TT-CTT": "Couva-Tabaquite-Talparo",
  "TT-DMN": "Diego Martin",
  "TT-MRC": "Mayaro-Rio Claro",
  "TT-PED": "Penal-Debe",
  "TT-POS": "Port of Spain",
  "TT-PRT": "Princes Town",
  "TT-PTF": "Point Fortin",
  "TT-SFO": "San Fernando",
  "TT-SIP": "Siparia",
  "TT-SJL": "San Juan-Laventille",
  "TT-TUP": "Tunapuna-Piarco",
  "TV-FUN": "Funafuti",
  "TV-NIT": "Niutao",
  "TV-NKF": "Nukufetau",
  "TV-NKL": "Nukulaelae",
  "TV-NMA": "Nanumea",
  "TV-NMG": "Nanumanga",
  "TV-NUI": "Nui",
  "TV-VAI": "Vaitupu",
  "TZ-01": "Arusha",
  "TZ-02": "Dar es Salaam",
  "TZ-03": "Dodoma",
  "TZ-04": "Iringa",
  "TZ-05": "Kagera",
  "TZ-06": "North Pemba",
  "TZ-07": "Zanzibar North",
  "TZ-08": "Kigoma",
  "TZ-09": "Kilimanjaro",
  "TZ-10": "South Pemba",
  "TZ-11": "Zanzibar Central/South",
  "TZ-12": "Lindi",
  "TZ-13": "Mara",
  "TZ-14": "Mbeya",
  "TZ-15": "Zanzibar Urban/West",
  "TZ-16": "Morogoro",
  "TZ-17": "Mtwara",
  "TZ-18": "Mwanza",
  "TZ-19": "Pwani",
  "TZ-20": "Rukwa",
  "TZ-21": "Ruvuma",
  "TZ-22": "Shinyanga",
  "TZ-23": "Singida",
  "TZ-24": "Tabora",
  "TZ-25": "Tanga",
  "TZ-26": "Manyara",
  "TZ-27": "Geita",
  "TZ-28": "Katavi",
  "TZ-29": "Njombe",
  "TZ-30": "Simiyu",
  "TZ-31": "Songwe",
  "UA-05": "Vinnychchyna",
  "UA-07": "Volyn",
  "UA-09": "Luhanshchyna",
  "UA-12": "Dnipropetrovshchyna",
  "UA-14": "Donechchyna",
  "UA-18": "Zhytomyrshchyna",
  "UA-21": "Zakarpattia",
  "UA-23": "Zaporizhzhya",
  "UA-26": "Prykarpattia",
  "UA-30": "Kyiv",
  "UA-32": "Kyivshchyna",
  "UA-35": "Kirovohradschyna",
  "UA-40": "Sevastopol",
  "UA-43": "Crimea",
  "UA-46": "Lvivshchyna",
  "UA-48": "Mykolayivschyna",
  "UA-51": "Odeshchyna",
  "UA-53": "Poltavshchyna",
  "UA-56": "Rivnenshchyna",
  "UA-59": "Sumshchyna",
  "UA-61": "Ternopilshchyna",
  "UA-63": "Kharkivshchyna",
  "UA-65": "Khersonshchyna",
  "UA-68": "Khmelnychchyna",
  "UA-71": "Cherkashchyna",
  "UA-74": "Chernihivshchyna",
  "UA-77": "Chernivtsi Oblast",
  "UG-C": "Central",
  "UG-E": "Eastern",
  "UG-N": "Northern",
  "UG-W": "Western",
  "US-AK": "Alaska",
  "US-AL": "Alabama",
  "US-AR": "Arkansas",
  "US-AZ": "Arizona",
  "US-CA": "California",
  "US-CO": "Colorado",
  "US-CT": "Connecticut",
  "US-DC": "Washington DC",
  "US-DE": "Delaware",
  "US-FL": "Florida",
  "US-GA": "Georgia",
  "US-HI": "Hawaii",
  "US-IA": "Iowa",
  "US-ID": "Idaho",
  "US-IL": "Illinois",
  "US-IN": "Indiana",
  "US-KS": "Kansas",
  "US-KY": "Kentucky",
  "US-LA": "Louisiana",
  "US-MA": "Massachusetts",
  "US-MD": "Maryland",
  "US-ME": "Maine",
  "US-MI": "Michigan",
  "US-MN": "Minnesota",
  "US-MO": "Missouri",
  "US-MS": "Mississippi",
  "US-MT": "Montana",
  "US-NC": "North Carolina",
  "US-ND": "North Dakota",
  "US-NE": "Nebraska",
  "US-NH": "New Hampshire",
  "US-NJ": "New Jersey",
  "US-NM": "New Mexico",
  "US-NV": "Nevada",
  "US-NY": "New York",
  "US-OH": "Ohio",
  "US-OK": "Oklahoma",
  "US-OR": "Oregon",
  "US-PA": "Pennsylvania",
  "US-RI": "Rhode Island",
  "US-SC": "South Carolina",
  "US-SD": "South Dakota",
  "US-TN": "Tennessee",
  "US-TX": "Texas",
  "US-UT": "Utah",
  "US-VA": "Virginia",
  "US-VT": "Vermont",
  "US-WA": "Washington",
  "US-WI": "Wisconsin",
  "US-WV": "West Virginia",
  "US-WY": "Wyoming",
  "UY-AR": "Artigas",
  "UY-CA": "Canelones",
  "UY-CL": "Cerro Largo",
  "UY-CO": "Colonia",
  "UY-DU": "Durazno",
  "UY-FD": "Florida",
  "UY-FS": "Flores",
  "UY-LA": "Lavalleja",
  "UY-MA": "Maldonado",
  "UY-MO": "Montevideo",
  "UY-PA": "Paysandú",
  "UY-RN": "Río Negro",
  "UY-RO": "Rocha",
  "UY-RV": "Rivera",
  "UY-SA": "Salto",
  "UY-SJ": "San José",
  "UY-SO": "Soriano",
  "UY-TA": "Tacuarembó",
  "UY-TT": "Treinta y Tres",
  "UZ-AN": "Andijan",
  "UZ-BU": "Bukhara",
  "UZ-FA": "Fergana",
  "UZ-JI": "Jizzakh",
  "UZ-NG": "Namangan",
  "UZ-NW": "Navoiy",
  "UZ-QA": "Qashqadaryo",
  "UZ-QR": "Karakalpakstan",
  "UZ-SA": "Samarqand",
  "UZ-SI": "Sirdaryo",
  "UZ-SU": "Surxondaryo",
  "UZ-TK": "Tashkent",
  "UZ-TO": "Tashkent Province",
  "UZ-XO": "Xorazm",
  "VE-A": "Capital",
  "VE-B": "Anzoátegui",
  "VE-C": "Apure",
  "VE-D": "Aragua",
  "VE-E": "Barinas",
  "VE-F": "Bolívar",
  "VE-G": "Carabobo",
  "VE-H": "Cojedes",
  "VE-I": "Falcón",
  "VE-J": "Guárico",
  "VE-K": "Lara",
  "VE-L": "Mérida",
  "VE-M": "Miranda",
  "VE-N": "Monagas",
  "VE-O": "Nueva Esparta",
  "VE-P": "Portuguesa",
  "VE-R": "Sucre",
  "VE-S": "Táchira",
  "VE-T": "Trujillo",
  "VE-U": "Yaracuy",
  "VE-V": "Zulia",
  "VE-W": "Federal Dependencies",
  "VE-X": "Vargas",
  "VE-Y": "Delta Amacuro",
  "VE-Z": "Amazonas",
  "VN-01": "Lai Châu",
  "VN-02": "Lào Cai",
  "VN-03": "Hà Giang",
  "VN-04": "Cao Bằng",
  "VN-05": "Sơn La",
  "VN-06": "Yên Bái",
  "VN-07": "Tuyên Quang",
  "VN-09": "Lạng Sơn",
  "VN-13": "Quảng Ninh",
  "VN-14": "Hòa Bình",
  "VN-18": "Ninh Bình",
  "VN-20": "Thái Bình",
  "VN-21": "Thanh Hóa",
  "VN-22": "Nghệ An",
  "VN-23": "Hà Tĩnh",
  "VN-24": "Quảng Bình",
  "VN-25": "Quảng Trị",
  "VN-26": "Thừa Thiên–Huế",
  "VN-27": "Quảng Nam",
  "VN-28": "Kon Tum",
  "VN-29": "Quảng Ngãi",
  "VN-30": "Gia Lai",
  "VN-31": "Bình Định",
  "VN-32": "Phú Yên",
  "VN-33": "Đắk Lắk",
  "VN-34": "Khánh Hòa",
  "VN-35": "Lâm Đồng",
  "VN-36": "Ninh Thuận",
  "VN-37": "Tây Ninh",
  "VN-39": "Đồng Nai",
  "VN-40": "Bình Thuận",
  "VN-41": "Long An",
  "VN-43": "Bà Rịa–Vũng Tàu",
  "VN-44": "An Giang",
  "VN-45": "Đồng Tháp",
  "VN-46": "Tiền Giang",
  "VN-47": "Kiên Giang",
  "VN-49": "Vĩnh Long",
  "VN-50": "Bến Tre",
  "VN-51": "Trà Vinh",
  "VN-52": "Sóc Trăng",
  "VN-53": "Bắc Kạn",
  "VN-54": "Bắc Giang",
  "VN-55": "Bạc Liêu",
  "VN-56": "Bắc Ninh",
  "VN-57": "Bình Dương",
  "VN-58": "Bình Phước",
  "VN-59": "Cà Mau",
  "VN-61": "Hải Dương",
  "VN-63": "Hà Nam",
  "VN-CT": "Can Tho",
  "VN-DN": "Da Nang",
  "VN-HN": "Hanoi",
  "VN-HP": "Haiphong",
  "VN-SG": "Ho Chi Minh City",
  "VU-MAP": "Malampa",
  "VU-PAM": "Penama",
  "VU-SAM": "Sanma",
  "VU-SEE": "Shefa",
  "VU-TAE": "Tafea",
  "VU-TOB": "Torba",
  "WS-AA": "A’ana",
  "WS-AL": "Aiga-i-le-Tai",
  "WS-AT": "Atua",
  "WS-FA": "Fa’asaleleaga",
  "WS-GE": "Gaga’emauga",
  "WS-GI": "Gaga’ifomauga",
  "WS-PA": "Palauli",
  "WS-SA": "Satupa’itea",
  "WS-TU": "Tuamasaga",
  "WS-VF": "Va’a-o-Fonoti",
  "WS-VS": "Vaisigano",
  "YE-AB": "Abyan",
  "YE-AD": "’Adan",
  "YE-AM": "Amran",
  "YE-BA": "Al Bayda",
  "YE-DA": "Dhale",
  "YE-DH": "Dhamar",
  "YE-HD": "Hadramaut",
  "YE-HJ": "Hajjah",
  "YE-HU": "Al Hudaydah",
  "YE-IB": "Ibb",
  "YE-JA": "Al Jawf",
  "YE-LA": "Lahij",
  "YE-MA": "Ma’rib",
  "YE-MR": "Al Mahrah",
  "YE-MW": "Al Mahwit",
  "YE-RA": "Raymah",
  "YE-SA": "Amanat Al Asimah",
  "YE-SD": "Sa’dah",
  "YE-SH": "Shabwah",
  "YE-SN": "Sana’a",
  "YE-TA": "Taiz",
  "ZA-EC": "Eastern Cape",
  "ZA-FS": "Free State",
  "ZA-KZN": "KwaZulu-Natal",
  "ZA-LP": "Limpopo",
  "ZA-MP": "Mpumalanga",
  "ZA-NC": "Northern Cape",
  "ZA-NW": "North West",
  "ZA-WC": "Western Cape",
  "ZM-01": "Western",
  "ZM-02": "Central",
  "ZM-03": "Eastern",
  "ZM-04": "Luapula",
  "ZM-05": "Northern",
  "ZM-06": "North-Western",
  "ZM-07": "Southern",
  "ZM-08": "Copperbelt",
  "ZM-09": "Lusaka",
  "ZM-10": "Muchinga",
  "ZW-BU": "Bulawayo",
  "ZW-HA": "Harare",
  "ZW-MA": "Manicaland",
  "ZW-MC": "Mashonaland Central",
  "ZW-ME": "Mashonaland East",
  "ZW-MI": "Midlands",
  "ZW-MN": "Matabeleland North",
  "ZW-MS": "Matabeleland South",
  "ZW-MV": "Masvingo",
  "ZW-MW": "Mashonaland West",
};
